<div class="app-container">
  <div class="studioWrapper">
    <div class="headerContainer">
      <div class="headerRow">
        <div class="headerLeft">
          <div class="headerButton" *ngFor="let item of toolbars.slice(0, 6)" (click)="newLayer(item)">
            <svg width="16" height="16" viewBox="0 0 16 16" class="bi bi-fonts" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg" *ngIf="item?.type == 'text'">
              <path
                d="M12.258 3H3.747l-.082 2.46h.479c.26-1.544.758-1.783 2.693-1.845l.424-.013v7.827c0 .663-.144.82-1.3.923v.52h4.082v-.52c-1.162-.103-1.306-.26-1.306-.923V3.602l.43.013c1.935.062 2.434.301 2.694 1.846h.479L12.258 3z" />
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-music-note-beamed" viewBox="0 0 16 16" *ngIf="item?.type == 'lyric'">
              <path
                d="M6 13c0 1.105-1.12 2-2.5 2S1 14.105 1 13c0-1.104 1.12-2 2.5-2s2.5.896 2.5 2zm9-2c0 1.105-1.12 2-2.5 2s-2.5-.895-2.5-2 1.12-2 2.5-2 2.5.895 2.5 2z" />
              <path fill-rule="evenodd" d="M14 11V2h1v9h-1zM6 3v10H5V3h1z" />
              <path d="M5 2.905a1 1 0 0 1 .9-.995l8-.8a1 1 0 0 1 1.1.995V3L5 4V2.905z" />
            </svg>

            <svg width="16" height="16" viewBox="0 0 16 16" class="bi bi-image" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg" *ngIf="item?.type == 'image'">
              <path fill-rule="evenodd"
                d="M14.002 2h-12a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-12-1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12z" />
              <path
                d="M10.648 7.646a.5.5 0 0 1 .577-.093L15.002 9.5V14h-14v-2l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71z" />
              <path fill-rule="evenodd" d="M4.502 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-play-btn-fill" viewBox="0 0 16 16" *ngIf="item?.type == 'video'">
              <path
                d="M0 12V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm6.79-6.907A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-music-note-list" viewBox="0 0 16 16" *ngIf="item?.type == 'compilation'">
              <path d="M12 13c0 1.105-1.12 2-2.5 2S7 14.105 7 13s1.12-2 2.5-2 2.5.895 2.5 2z" />
              <path fill-rule="evenodd" d="M12 3v10h-1V3h1z" />
              <path d="M11 2.82a1 1 0 0 1 .804-.98l3-.6A1 1 0 0 1 16 2.22V4l-5 1V2.82z" />
              <path fill-rule="evenodd"
                d="M0 11.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 .5 7H8a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 .5 3H8a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5z" />
            </svg>

            <svg *ngIf="item?.type == 'mix_lyric'" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
              fill="currentColor" class="bi bi-shuffle" viewBox="0 0 16 16">
              <path fill-rule="evenodd"
                d="M0 3.5A.5.5 0 0 1 .5 3H1c2.202 0 3.827 1.24 4.874 2.418.49.552.865 1.102 1.126 1.532.26-.43.636-.98 1.126-1.532C9.173 4.24 10.798 3 13 3v1c-1.798 0-3.173 1.01-4.126 2.082A9.624 9.624 0 0 0 7.556 8a9.624 9.624 0 0 0 1.317 1.918C9.828 10.99 11.204 12 13 12v1c-2.202 0-3.827-1.24-4.874-2.418A10.595 10.595 0 0 1 7 9.05c-.26.43-.636.98-1.126 1.532C4.827 11.76 3.202 13 1 13H.5a.5.5 0 0 1 0-1H1c1.798 0 3.173-1.01 4.126-2.082A9.624 9.624 0 0 0 6.444 8a9.624 9.624 0 0 0-1.317-1.918C4.172 5.01 2.796 4 1 4H.5a.5.5 0 0 1-.5-.5z" />
              <path
                d="M13 5.466V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192zm0 9v-3.932a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192z" />
            </svg>

            {{ item?.text }}
          </div>

          <div class="dropdown">
            <button type="button" class="btn btn-link text-light d-flex align-items-center" data-toggle="dropdown">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                class="bi bi-three-dots" viewBox="0 0 16 16">
                <path
                  d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
              </svg>
            </button>

            <div class="dropdown-menu dropdown-menu-right bg-dark">
              <button (click)="newLayer(item)" *ngFor="let item of toolbars.slice(6)" type="button"
                class="dropdown-item bg-dark text-light d-flex align-items-center">
                <svg *ngIf="item?.type == 'motion'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-boxes mr-2" viewBox="0 0 16 16">
                  <path d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434zM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567zM7.5 9.933l-2.75 1.571v3.134l2.75-1.571zm1 3.134 2.75 1.571v-3.134L8.5 9.933zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567zm2.242-2.433V3.504L8.5 5.076V8.21zM7.5 8.21V5.076L4.75 3.504v3.134zM5.258 2.643 8 4.21l2.742-1.567L8 1.076zM15 9.933l-2.75 1.571v3.134L15 13.067zM3.75 14.638v-3.134L1 9.933v3.134z"/>
                </svg>

                <svg *ngIf="item?.type == 'text_list'" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  fill="currentColor" class="bi bi-textarea-t mr-2" viewBox="0 0 16 16">
                  <path
                    d="M1.5 2.5A1.5 1.5 0 0 1 3 1h10a1.5 1.5 0 0 1 1.5 1.5v3.563a2 2 0 0 1 0 3.874V13.5A1.5 1.5 0 0 1 13 15H3a1.5 1.5 0 0 1-1.5-1.5V9.937a2 2 0 0 1 0-3.874zm1 3.563a2 2 0 0 1 0 3.874V13.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9.937a2 2 0 0 1 0-3.874V2.5A.5.5 0 0 0 13 2H3a.5.5 0 0 0-.5.5zM2 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2m12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                  <path
                    d="M11.434 4H4.566L4.5 5.994h.386c.21-1.252.612-1.446 2.173-1.495l.343-.011v6.343c0 .537-.116.665-1.049.748V12h3.294v-.421c-.938-.083-1.054-.21-1.054-.748V4.488l.348.01c1.56.05 1.963.244 2.173 1.496h.386z" />
                </svg>

                <svg *ngIf="item?.type == 'footage'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-film mr-2" viewBox="0 0 16 16">
                  <path d="M0 1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm4 0v6h8V1zm8 8H4v6h8zM1 1v2h2V1zm2 3H1v2h2zM1 7v2h2V7zm2 3H1v2h2zm-2 3v2h2v-2zM15 1h-2v2h2zm-2 3v2h2V4zm2 3h-2v2h2zm-2 3v2h2v-2zm2 3h-2v2h2z"/>
                </svg>

                <svg *ngIf="item?.type == 'element'" width="16" height="16" viewBox="0 0 16 16"
                  class="bi bi-grid-fill mr-2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z" />
                </svg>

                {{ item?.text }}
              </button>
            </div>
          </div>
        </div>

        <div class="headerRight">
          <button (click)="btnShowEnv()" type="button" class="btn btn-link text-light d-flex align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-at"
              viewBox="0 0 16 16" data-toggle="tooltip" data-container=".headerRight" data-placement="bottom"
              title="Environment variables">
              <path
                d="M13.106 7.222c0-2.967-2.249-5.032-5.482-5.032-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.43.199-1.354.328-2.29.328-2.926 0-4.813-1.88-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.416 2.769-.492 0-.772-.28-.772-.76V5.206H8.923v.834h-.11c-.266-.595-.881-.964-1.6-.964-1.4 0-2.378 1.162-2.378 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.11c.081.67.703 1.148 1.503 1.148 1.572 0 2.57-1.415 2.57-3.643zm-7.177.704c0-1.197.54-1.907 1.456-1.907.93 0 1.524.738 1.524 1.907S8.308 9.84 7.371 9.84c-.895 0-1.442-.725-1.442-1.914z" />
            </svg>
          </button>

          <div class="bg-dark rounded mr-3 d-flex align-items-center">
            <select class="custom-select bg-dark border-dark text-light" (change)="hubChange($event)"
              [disabled]="isLoading">
              <option value="-1">Choose hub</option>
              <option [selected]="item?.id == currentHub?.id" [value]="item?.id" [attr.name]="item?.name"
                *ngFor="let item of hubList">
                {{ item?.name }}_{{ item?.id }}</option>
            </select>

            <a href="#" class="btn btn-link text-light p-1 d-flex justify-content-center" (click)="newHub()">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-plus-lg"
                viewBox="0 0 16 16" data-toggle="tooltip" data-container=".headerRight" data-placement="bottom"
                title="New hub">
                <path d="M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z" />
              </svg>
            </a>

            <a href="#" class="btn btn-link text-light p-1 d-flex justify-content-center" data-toggle="modal"
              data-target="#templateModal" (click)="saveHubClick()">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-check-lg"
                viewBox="0 0 16 16" data-toggle="tooltip" data-container=".headerRight" data-placement="bottom"
                title="Save hub">
                <path
                  d="M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.82-8.69a.486.486 0 0 1 .04-.045z" />
              </svg>
            </a>
          </div>

          <div class="bg-dark rounded mr-3 d-flex align-items-center">
            <select class="custom-select bg-dark border-dark text-light" (change)="templateChange($event)"
              [disabled]="isLoading">
              <option value="-1">Choose template</option>
              <option [selected]="item?.id == currentTemplate?.id" [value]="item?.id" [attr.name]="item?.name"
                *ngFor="let item of templateList">
                {{ item?.name }}_{{ item?.id }}</option>
            </select>

            <a href="#" class="btn btn-link text-light p-1 d-flex justify-content-center" (click)="newTemplate()">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-plus-lg"
                viewBox="0 0 16 16" data-toggle="tooltip" data-container=".headerRight" data-placement="bottom"
                title="New template">
                <path d="M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z" />
              </svg>
            </a>

            <a href="#" class="btn btn-link text-light p-1 d-flex justify-content-center" data-toggle="modal"
              data-target="#templateModal" (click)="templateType = 'saveTemplate'">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-check-lg"
                viewBox="0 0 16 16" data-toggle="tooltip" data-container=".headerRight" data-placement="bottom"
                title="Save template">
                <path
                  d="M13.485 1.431a1.473 1.473 0 0 1 2.104 2.062l-7.84 9.801a1.473 1.473 0 0 1-2.12.04L.431 8.138a1.473 1.473 0 0 1 2.084-2.083l4.111 4.112 6.82-8.69a.486.486 0 0 1 .04-.045z" />
              </svg>
            </a>
          </div>

          <div class="mr-3">
            <div class="input-group">
              <input #channelInput (ngModelChange)="channelChange($event)" [ngModel]="channel?.name" list="channels"
                class="form-control bg-dark border-dark text-light" type="text">
              <div (click)="channelInput.value = ''" role="button" class="input-group-append">
                <span class="input-group-text bg-dark border-dark text-light">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg"
                    viewBox="0 0 16 16">
                    <path
                      d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
                  </svg>
                </span>
              </div>
            </div>

            <datalist id="channels">
              <option [value]="item?.chanel_id" *ngFor="let item of channelList">{{ item?.chanel_name }}</option>
            </datalist>
          </div>

          <div class="btn-group mr-3" role="group">
            <button type="button" class="btn btn-secondary" (click)="renderTest()">
              <span *ngIf="isSpinner == 'test'; else elseBlock" class="spinner-border spinner-border-sm" role="status"></span>
              <ng-template #elseBlock>Test</ng-template>
            </button>
            <button type="button" class="btn btn-secondary" (click)="showPreview()">Preview</button>
          </div>

          <a class="btn btn-primary text-truncate mr-3" target="_blank" href="results">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download"
              viewBox="0 0 16 16">
              <path
                d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
              <path
                d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
            </svg>
            Results
          </a>

          <button type="button" class="btn btn-danger" data-toggle="modal" data-target="#saveModal">Render</button>

          <div class="dropdown">
            <button type="button" class="btn btn-link text-light d-flex align-items-center" data-toggle="dropdown">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                class="bi bi-three-dots" viewBox="0 0 16 16">
                <path
                  d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
              </svg>
            </button>

            <div class="dropdown-menu dropdown-menu-right bg-dark">
              <h6 class="dropdown-header text-light">Hi, {{ username }}</h6>

              <button *ngIf="['sangmusic', 'tungtt'].includes(username)" data-target="#viewer-modal"
                data-toggle="modal" class="dropdown-item bg-dark text-light d-flex align-items-center" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-eye mr-2" viewBox="0 0 16 16">
                  <path
                    d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                  <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                </svg>
                Viewer
              </button>

              <button data-target="#checkMusicModal" data-toggle="modal"
                class="dropdown-item bg-dark text-light d-flex align-items-center" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-music-note mr-2" viewBox="0 0 16 16">
                  <path d="M9 13c0 1.105-1.12 2-2.5 2S4 14.105 4 13s1.12-2 2.5-2 2.5.895 2.5 2"/>
                  <path fill-rule="evenodd" d="M9 3v10H8V3z"/>
                  <path d="M8 2.82a1 1 0 0 1 .804-.98l3-.6A1 1 0 0 1 13 2.22V4L8 5z"/>
                </svg>
                Music Checking
              </button>

              <button data-target="#boomMixModal" data-toggle="modal"
                class="dropdown-item bg-dark text-light d-flex align-items-center" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-circle-fill mr-2" viewBox="0 0 16 16">
                  <circle cx="8" cy="8" r="8" />
                </svg>
                Boom Mix
              </button>

              <button data-target="#collectionModal" data-toggle="modal"
                class="dropdown-item bg-dark text-light d-flex align-items-center" type="button">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-collection mr-2" viewBox="0 0 16 16">
                  <path
                    d="M2.5 3.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1h-7zM0 13a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 16 13V6a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 0 6v7zm1.5.5A.5.5 0 0 1 1 13V6a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-13z" />
                </svg>
                Collection
              </button>

              <button class="dropdown-item bg-dark text-light d-flex align-items-center" type="button"
                (click)="previewSpinnerText()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-braces mr-2" viewBox="0 0 16 16">
                  <path d="M2.114 8.063V7.9c1.005-.102 1.497-.615 1.497-1.6V4.503c0-1.094.39-1.538 1.354-1.538h.273V2h-.376C3.25 2 2.49 2.759 2.49 4.352v1.524c0 1.094-.376 1.456-1.49 1.456v1.299c1.114 0 1.49.362 1.49 1.456v1.524c0 1.593.759 2.352 2.372 2.352h.376v-.964h-.273c-.964 0-1.354-.444-1.354-1.538V9.663c0-.984-.492-1.497-1.497-1.6M13.886 7.9v.163c-1.005.103-1.497.616-1.497 1.6v1.798c0 1.094-.39 1.538-1.354 1.538h-.273v.964h.376c1.613 0 2.372-.759 2.372-2.352v-1.524c0-1.094.376-1.456 1.49-1.456V7.332c-1.114 0-1.49-.362-1.49-1.456V4.352C13.51 2.759 12.75 2 11.138 2h-.376v.964h.273c.964 0 1.354.444 1.354 1.538V6.3c0 .984.492 1.497 1.497 1.6"/>
                </svg>
                Spinner
              </button>

              <a class="dropdown-item bg-dark text-light d-flex align-items-center" target="_blank" href="duotone">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-circle-half mr-2" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z" />
                </svg>
                Duotone
              </a>

              <a class="dropdown-item bg-dark text-light d-flex align-items-center" target="_blank" href="stocks">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-images mr-2" viewBox="0 0 16 16">
                  <path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
                  <path
                    d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2zM14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1zM2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1h-10z" />
                </svg>
                Stocks
              </a>

              <button class="dropdown-item bg-dark text-light d-flex align-items-center" type="button"
                data-toggle="modal" data-target="#settings">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-gear mr-2" viewBox="0 0 16 16">
                  <path
                    d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
                  <path
                    d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
                </svg>
                Settings
              </button>

              <button class="dropdown-item bg-dark text-light d-flex align-items-center" type="button"
                data-toggle="modal" data-target="#clearStorage">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-trash mr-2" viewBox="0 0 16 16">
                  <path
                    d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                  <path fill-rule="evenodd"
                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                </svg>
                Clear storage
              </button>

              <button class="dropdown-item bg-dark text-light d-flex align-items-center" type="button"
                data-toggle="modal" data-target="#helpModal">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-question-circle mr-2" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path
                    d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                </svg>
                Help
              </button>

              <button class="dropdown-item bg-dark text-light d-flex align-items-center" type="button"
                (click)="logout()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-box-arrow-in-right mr-2" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z" />
                  <path fill-rule="evenodd"
                    d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z" />
                </svg>
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid editorContainer">
      <div class="row editor">
        <div class="col-md-2 studioLeft">
          <app-layer [layers]="layers" [previews]="previews" [selectedLayerId]="layerData?.id"
            [hubList]="autoTemplate?.hub" (changedLayer)="changedLayer($event)">
          </app-layer>
        </div>

        <div class="col-md position-relative studioBody">
          <div id="modal-preivew" class="modal fade" tabindex="-1">
            <div class="modal-dialog modal-xl modal-dialog-centered"
              [ngStyle]="{ 'width.px': dimensions?.workspaceWidth, 'min-height.px': dimensions?.workspaceHeight }">
              <div class="modal-content bg-dark text-light border border-secondary" style="overflow: hidden;">
                <div class="modal-header">
                  <ng-container *ngIf="testJob.hasOwnProperty('id')">
                    <h5 class="modal-title">ID {{ testJob?.id }}</h5>
                    <button type="button" class="btn btn-sm btn-primary ml-3" data-toggle="modal"
                      data-target="#metaModal">Meta</button>
                    <button type="button" class="btn btn-sm btn-success ml-2" (click)="submitRenderTestJob()"
                      [disabled]="isSpinner == 'render-test'">Render test</button>
                  </ng-container>
                  <button type="button" class="close" data-dismiss="modal">
                    <span>&times;</span>
                  </button>
                </div>

                <div class="modal-body modal-preview-body p-0"></div>

                <div class="modal-footer">
                  <div class="playtime">
                    <label id="cur">00:00</label> / <label id="dur">00:00</label>
                  </div>
                  <div class="playcontrols">
                    <button type="button" (click)="preview($event)" value="1" class="btn btn-sm btn-audio-control"
                      id="playpausebtn">
                      <svg id="playpausebtnsvg" width="16" height="16" viewBox="0 0 16 16" class="bi bi-play-fill"
                        fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z" />
                      </svg>
                    </button>
                    <input id="seekslider" type="range" min="0" max="100" value="0" step="0.01">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="alertMessage" class="alert alert-warning alert-dismissible fade show" role="alert">
            <strong>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-exclamation-triangle mr-2" viewBox="0 0 16 16">
                <path
                  d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
                <path
                  d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
              </svg>
            </strong>
            {{ alertMessage }}
            <button type="button" class="close" data-dismiss="alert">
              <span>&times;</span>
            </button>
          </div>

          <button (click)="genThumb($event)" data-toggle="tooltip" data-placement="bottom" title="Generate thumbnails"
            type="button" class="btn btn-sm btn-link position-absolute position-top">
            <span *ngIf="isSpinner == 'genThumb'" class="spinner-border spinner-border-sm mr-2" role="status"></span>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
              class="bi bi-camera pe-none" viewBox="0 0 16 16">
              <path
                d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z" />
              <path
                d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
            </svg>
          </button>

          <label>{{ outputWidth }} x {{ outputHeight }}</label>

          <div class="workspace"
            [ngStyle]="{ 'width.px': dimensions?.workspaceWidth, 'min-height.px': dimensions?.workspaceHeight }">
            <div class="canvas" [attr.data-id]="layer?.id" [ngStyle]="getPreview(layer?.id, 'layer')"
              [ngClass]="{ canvasActive: layer?.id == layerData?.id }" *ngFor="let layer of layers"
              (click)="selectedLayer(layer)">
              <div id="{{layer?.id}}_{{layer?.type}}_text" [ngStyle]="getPreview(layer?.id, 'text_list')"
                class="canvasText">{{ layer?.text }}</div>

              <div id="{{layer?.id}}_{{layer?.type}}" class="canvasImage"
                *ngIf="layer?.type == 'image' && layer?.directUrl != null" [ngStyle]="getPreview(layer?.id, 'image')">
              </div>

              <div class="canvasVideo" *ngIf="layer?.type?.includes('video') && layer?.directUrl != null">
                <video id="{{layer?.id}}_video" [poster]="layer?.poster" [ngStyle]="getPreview(layer?.id, 'video')"
                  controls>
                  <source [src]="layer?.directUrl" id="{{layer?.id}}_videosource">
                </video>
              </div>

              <audio id="{{layer?.id}}_player" preload="auto" *ngIf="layer?.type == 'lyric'">
                <source [src]="layer?.audio_url" id="{{layer?.id}}_audiosource">
              </audio>

              <div class="directionContainer" *ngIf="layer?.type == 'element'">
                <svg [ngClass]="{ 'directionActive': layer?.arr_direction.indexOf(7) > -1 }" (click)="directionClick(7)"
                  width="16" height="16" viewBox="0 0 16 16" class="bi bi-arrow-up-left direction7" fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M2 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H3.707l10.147 10.146a.5.5 0 0 1-.708.708L3 3.707V8.5a.5.5 0 0 1-1 0v-6z" />
                </svg>
                <svg [ngClass]="{ 'directionActive': layer?.arr_direction.indexOf(0) > -1 }" (click)="directionClick(0)"
                  width="16" height="16" viewBox="0 0 16 16" class="bi bi-arrow-up direction0" fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" />
                </svg>
                <svg [ngClass]="{ 'directionActive': layer?.arr_direction.indexOf(1) > -1 }" (click)="directionClick(1)"
                  width="16" height="16" viewBox="0 0 16 16" class="bi bi-arrow-up-right direction1" fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0v-6z" />
                </svg>

                <svg [ngClass]="{ 'directionActive': layer?.arr_direction.indexOf(6) > -1 }" (click)="directionClick(6)"
                  width="16" height="16" viewBox="0 0 16 16" class="bi bi-arrow-left direction6" fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
                </svg>
                <svg [ngClass]="{ 'directionActive': layer?.arr_direction.indexOf(2) > -1 }" (click)="directionClick(2)"
                  width="16" height="16" viewBox="0 0 16 16" class="bi bi-arrow-right direction2" fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
                </svg>

                <svg [ngClass]="{ 'directionActive': layer?.arr_direction.indexOf(5) > -1 }" (click)="directionClick(5)"
                  width="16" height="16" viewBox="0 0 16 16" class="bi bi-arrow-down-left direction5"
                  fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M2 13.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 0-1H3.707L13.854 2.854a.5.5 0 0 0-.708-.708L3 12.293V7.5a.5.5 0 0 0-1 0v6z" />
                </svg>
                <svg [ngClass]="{ 'directionActive': layer?.arr_direction.indexOf(4) > -1 }" (click)="directionClick(4)"
                  width="16" height="16" viewBox="0 0 16 16" class="bi bi-arrow-down direction4" fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z" />
                </svg>
                <svg [ngClass]="{ 'directionActive': layer?.arr_direction.indexOf(3) > -1 }" (click)="directionClick(3)"
                  width="16" height="16" viewBox="0 0 16 16" class="bi bi-arrow-down-right direction3"
                  fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M14 13.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1 0-1h4.793L2.146 2.854a.5.5 0 1 1 .708-.708L13 12.293V7.5a.5.5 0 0 1 1 0v6z" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-2 studioRight">
          <app-control [controlType]="controlType" [layers]="layers" [layerData]="layerData" [isPortrait]="isPortrait"
            [fontList]="{'results': defaultFonts, 'page': 1}" [boomGenres]="boomGenres" [lyricData]="lyricData" [lyricSource]="lyricSource"
            [langCodeList]="langCodeList" [currentHub]="currentHub" (changedControl)="changedControl($event)">
          </app-control>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" tabindex="-1" id="settings">
  <div class="modal-dialog">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Settings</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="form-group row align-items-center">
          <label class="col-md col-form-label"></label>
          <div class="col-md-7 d-flex justify-content-around">
            <button
              type="button"
              class="btn btn-sm btn-outline-light"
              (click)="setResolution(1080, 1920)">
              Short FHD
            </button>

            <button
              type="button"
              class="btn btn-sm btn-outline-light"
              (click)="setResolution(1920, 1080)">
              Full HD
            </button>

            <button
              type="button"
              class="btn btn-sm btn-outline-light"
              (click)="setResolution(3840, 2160)">
              4K
            </button>

            <button
              type="button"
              class="btn btn-sm btn-outline-light"
              (click)="setResolution(7680, 4320)">
              8K
            </button>
          </div>
        </div>

        <div class="form-group row">
          <label for="outputWidth" class="col-md col-form-label">Output width</label>
          <div class="col-md-3">
            <input type="number" class="form-control bg-dark border-secondary text-light" id="outputWidth"
              [ngModel]="outputWidth" (ngModelChange)="outputWidthChange($event)" />
          </div>
        </div>

        <div class="form-group row">
          <label for="outputHeight" class="col-md col-form-label">Output height</label>
          <div class="col-md-3">
            <input type="number" class="form-control bg-dark border-secondary text-light" id="outputHeight"
              [ngModel]="outputHeight" (ngModelChange)="outputHeightChange($event)" />
          </div>
        </div>

        <div class="form-group row">
          <label for="defaultStep" class="col-md col-form-label">Default arrow step</label>
          <div class="col-md-3">
            <input type="number" class="form-control bg-dark border-secondary text-light" id="defaultStep"
              [ngModel]="defaultStep" (ngModelChange)="defaultStepChange($event)" />
          </div>
        </div>

        <div class="form-group row">
          <label for="thumbnailSeconds" class="col-md col-form-label">Generate thumbnails (seconds)</label>
          <div class="col-md-3">
            <input class="form-control bg-dark border-secondary text-light" id="thumbnailSeconds" type="number"
              [ngModel]="thumbnailSeconds" (ngModelChange)="thumbnailSecondsChange($event)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" tabindex="-1" id="saveModal">
  <div class="modal-dialog">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Save</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label for="projectName">Project name</label>
          <input type="text" class="form-control bg-dark border-secondary text-light" id="projectName"
            [ngModel]="projectName" (ngModelChange)="projectNameChange($event)" />
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="save($event)">Save changes</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="templateModal">
  <div [ngClass]="templateType == 'saveHub' ? 'modal-dialog modal-dialog-scrollable modal-xl' : 'modal-dialog'">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ templateType == 'newTemplate' || templateType == 'saveTemplate' || templateType == 'isSavedTemplate' ?
          'Template' : templateType == 'newHub' || templateType == 'isSavedHub' ? 'Hub' : 'Meta' }}
        </h5>
        <ng-container *ngIf="templateType == 'saveHub'">
          <button class="btn btn-sm btn-primary ml-2" (click)="previewSpinnerText()" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-braces" viewBox="0 0 16 16">
              <path d="M2.114 8.063V7.9c1.005-.102 1.497-.615 1.497-1.6V4.503c0-1.094.39-1.538 1.354-1.538h.273V2h-.376C3.25 2 2.49 2.759 2.49 4.352v1.524c0 1.094-.376 1.456-1.49 1.456v1.299c1.114 0 1.49.362 1.49 1.456v1.524c0 1.593.759 2.352 2.372 2.352h.376v-.964h-.273c-.964 0-1.354-.444-1.354-1.538V9.663c0-.984-.492-1.497-1.497-1.6M13.886 7.9v.163c-1.005.103-1.497.616-1.497 1.6v1.798c0 1.094-.39 1.538-1.354 1.538h-.273v.964h.376c1.613 0 2.372-.759 2.372-2.352v-1.524c0-1.094.376-1.456 1.49-1.456V7.332c-1.114 0-1.49-.362-1.49-1.456V4.352C13.51 2.759 12.75 2 11.138 2h-.376v.964h.273c.964 0 1.354.444 1.354 1.538V6.3c0 .984.492 1.497 1.497 1.6"/>
            </svg>
          </button>
          <button (click)="btnShowEnv()" class="btn btn-sm btn-primary ml-2" type="button">@</button>
          <button (click)="btnSuperCollection()" class="btn btn-sm btn-primary ml-2" type="button"
            data-toggle="tooltip" data-placement="top" title="Super Collection">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box2-heart mr-1" viewBox="0 0 16 16">
              <path d="M8 7.982C9.664 6.309 13.825 9.236 8 13 2.175 9.236 6.336 6.31 8 7.982"/>
              <path d="M3.75 0a1 1 0 0 0-.8.4L.1 4.2a.5.5 0 0 0-.1.3V15a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4.5a.5.5 0 0 0-.1-.3L13.05.4a1 1 0 0 0-.8-.4zm0 1H7.5v3h-6zM8.5 4V1h3.75l2.25 3zM15 5v10H1V5z"/>
            </svg>
            <ng-container *ngIf="autoTemplate.supc_id && autoTemplate.supc_id > 0">{{ autoTemplate.supc_id }}</ng-container>
          </button>
          <button data-toggle="modal" data-target="#hubAskMetaModal" type="button" class="btn btn-sm btn-info ml-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-stars" viewBox="0 0 16 16">
              <path d="M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.73 1.73 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.73 1.73 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.73 1.73 0 0 0 3.407 2.31zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z"/>
            </svg>
            Moon AI
          </button>
        </ng-container>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div *ngIf="templateType == 'saveTemplate'">
          <div class="form-group">
            <label for="tplName">Name</label>
            <input type="text" class="form-control bg-dark border-secondary text-light" id="tplName"
              [(ngModel)]="currentTemplate.name" />
          </div>
        </div>

        <p *ngIf="templateType == 'isSavedTemplate' || templateType == 'isSavedHub'">
          <span class="text-danger font-weight-bold">
            {{ templateType == 'isSavedTemplate' ? currentTemplate?.name : currentHub?.name }}
          </span>
          {{ templateType == 'isSavedTemplate' ? 'template' : 'hub' }} haven't been saved. Do you want to save it?
        </p>

        <div *ngIf="templateType == 'newTemplate'">
          <div class="form-group">
            <label for="tplName">Name</label>
            <input type="text" class="form-control bg-dark border-secondary text-light" id="tplName"
              [(ngModel)]="currentTemplate.name" />
          </div>

          <div class="form-row">
            <div class="col-md form-group">
              <label>Clone</label>
              <select [disabled]="template.example.template_id.length" [(ngModel)]="template.clone.template_id"
                class="custom-select bg-dark border-secondary text-light">
                <option value="">Choose template</option>
                <option [value]="item?.id" *ngFor="let item of templateList">
                  {{ item?.name }}_{{ item?.id}}
                </option>
              </select>
            </div>

            <div class="col-md form-group">
              <label>Example</label>
              <select [disabled]="template.clone.template_id.length" [(ngModel)]="template.example.template_id"
                class="custom-select bg-dark border-secondary text-light">
                <option value="">Choose example</option>
                <option [value]="item?.template_id" *ngFor="let item of template.example?.results">
                  {{ item?.name }}_{{ item?.id}}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div *ngIf="templateType == 'newHub'">
          <div class="form-row">
            <div class="col-md-4 form-group">
              <label>Type</label>
              <select class="form-control bg-dark border-secondary text-light" [(ngModel)]="autoTemplate.type">
                <option [selected]="autoTemplate?.type == 1" value="1">Lyric</option>
                <option [selected]="autoTemplate?.type == 2" value="2">Compilation</option>
                <option [selected]="autoTemplate?.type == 3" value="3">TikTok</option>
                <option [selected]="autoTemplate?.type == 4" value="4">Mix</option>
              </select>
            </div>

            <div class="col form-group">
              <label for="hubName">Name</label>
              <input type="text" class="form-control bg-dark border-secondary text-light" id="hubName"
                [(ngModel)]="currentHub.name" />
            </div>
          </div>
        </div>

        <div *ngIf="templateType == 'saveHub'">
          <div *ngIf="autoTemplate.status" class="alert alert-warning alert-dismissible fade show" role="alert">
            <strong>Hệ thống sẽ dừng mọi lệnh đã lên lịch nếu tắt Hub.</strong>
            <button type="button" class="close" data-dismiss="alert">
              <span>&times;</span>
            </button>
          </div>

          <div class="form-group">
            <div class="custom-control custom-switch custom-control-inline">
              <input type="checkbox" id="turnOffHub" class="custom-control-input" [(ngModel)]="autoTemplate.status">
              <label class="custom-control-label" for="turnOffHub" title="Default is On. Click to turn Off.">Turn Off</label>
            </div>

            <div *ngIf="autoTemplate?.post_type != 2" class="custom-control custom-checkbox custom-control-inline">
              <input type="checkbox" class="custom-control-input" id="isCrosspost" (change)="postTypeChange($event, 1)"
                [checked]="autoTemplate?.post_type == 1">
              <label class="custom-control-label" for="isCrosspost">Crossposting</label>
            </div>

            <div *ngIf="autoTemplate?.post_type != 1" class="custom-control custom-checkbox custom-control-inline">
              <input type="checkbox" class="custom-control-input" id="isPromo" (change)="postTypeChange($event, 2)"
                [checked]="autoTemplate?.post_type == 2">
              <label class="custom-control-label" for="isPromo">Auto Promo</label>
            </div>

            <div class="custom-control custom-checkbox custom-control-inline">
              <input type="checkbox" class="custom-control-input" id="isBoom" (change)="postTypeChange($event, 3)"
                [checked]="autoTemplate?.post_type == 3">
              <label class="custom-control-label" for="isBoom">Boom</label>
            </div>

            <div class="custom-control custom-checkbox custom-control-inline">
              <input type="checkbox" class="custom-control-input" id="autoSubmit" [ngModel]="autoTemplate.meta?.auto_submit == 1"
                (ngModelChange)="autoTemplate.meta.auto_submit = $event ? 1 : 0">
              <label class="custom-control-label" for="autoSubmit">Auto Submit Claim</label>
            </div>
          </div>

          <div class="custom-control custom-checkbox form-group">
            <input [(ngModel)]="autoTemplate.is_schedule" type="checkbox" class="custom-control-input" id="scheduleHub">
            <label class="custom-control-label" for="scheduleHub">Schedule Hub (Boom Timer)</label>
          </div>

          <div *ngIf="autoTemplate?.is_schedule" class="form-group border border-black rounded p-3">
            <div class="row align-items-start">
              <div class="col-md-3">
                <mat-form-field appearance="fill">
                  <mat-label>Stop</mat-label>
                  <input matInput [matDatepicker]="pickerOff" [value]="bindDate(autoTemplate?.time_stop)"
                    (dateChange)="scheduleHubChange($event, 'stop')">
                  <mat-datepicker-toggle matSuffix [for]="pickerOff"></mat-datepicker-toggle>
                  <mat-datepicker #pickerOff></mat-datepicker>
                </mat-form-field>
                <div class="btn-group btn-group-toggle mt-2" data-toggle="buttons">
                  <label *ngFor="let o of timeOptions" class="btn btn-secondary">
                    <input
                      (input)="btnTimeChange(o.value, 'stop')"
                      type="radio"
                      name="timeStop"
                      [id]="o.id">
                    {{ o.label }}
                  </label>
                </div>
              </div>

              <div class="col-md-3">
                <mat-form-field *ngIf="autoTemplate?.time_start > 0" appearance="fill">
                  <mat-label>Restart</mat-label>
                  <input matInput [matDatepicker]="pickerOn" [value]="bindDate(autoTemplate?.time_start)"
                    (dateChange)="scheduleHubChange($event, 'start')">
                  <mat-datepicker-toggle matSuffix [for]="pickerOn"></mat-datepicker-toggle>
                  <mat-datepicker #pickerOn></mat-datepicker>
                </mat-form-field>
                <div class="custom-control custom-checkbox mt-2">
                  <input type="checkbox" class="custom-control-input" id="autoRestart"
                    [checked]="autoTemplate?.time_start > 0" (change)="restartChange($event)">
                  <label class="custom-control-label" for="autoRestart">Restart <span
                      class="text-white-50">(Auto-stop after 1-3M)</span></label>
                </div>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md">
              <label for="hubName">Hub name</label>
              <input type="text" class="form-control bg-dark border-secondary text-light" id="hubName"
                [(ngModel)]="currentHub.name" />
            </div>

            <div class="form-group col-md">
              <label>Hub type</label>
              <select class="form-control bg-dark border-secondary text-light" [(ngModel)]="autoTemplate.type">
                <option [selected]="autoTemplate?.type == 1" value="1">Lyric</option>
                <option [selected]="autoTemplate?.type == 2" value="2">Compilation</option>
                <option [selected]="autoTemplate?.type == 3" value="3">TikTok</option>
                <option [selected]="autoTemplate?.type == 4" value="4">Mix</option>
              </select>
            </div>

            <div class="form-group col-md">
              <label for="hashSign">Hashtag sign (blank is no space)</label>
              <input type="text" class="form-control bg-dark border-secondary text-light" id="hashSign"
                [(ngModel)]="autoTemplate.meta.hash_sign" />
            </div>
          </div>

          <div class="form-group">
            <div class="d-flex align-items-center text-truncate mb-2">
              <label class="mr-3 mb-0" for="videoTitle">Title</label>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isTitleUpper"
                  (change)="isTextUpperChange($event, 'title')" [checked]="autoTemplate?.meta?.is_title_upper">
                <label class="custom-control-label" for="isTitleUpper">UPPERCASE</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="autoTemplate?.meta?.is_title_upper && !autoTemplate?.meta?.hasOwnProperty('title_ucword')">
                <input type="checkbox" class="custom-control-input" id="titleCap"
                  (change)="textCapChange($event, 'title')"
                  [checked]="autoTemplate?.meta?.hasOwnProperty('title_ucfirst')">
                <label class="custom-control-label" for="titleCap">Uppercase Firsts</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="autoTemplate?.meta?.is_title_upper && !autoTemplate?.meta?.hasOwnProperty('title_ucfirst') && !autoTemplate?.meta?.hasOwnProperty('title_lowercase')">
                <input type="checkbox" class="custom-control-input" id="titleUpper"
                  (change)="textUpperChange($event, 'title')"
                  [checked]="autoTemplate?.meta?.hasOwnProperty('title_ucword')">
                <label class="custom-control-label" for="titleUpper">UPPERCASE WORDS</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="!autoTemplate?.meta?.hasOwnProperty('title_ucword')">
                <input type="checkbox" class="custom-control-input" id="titleLower"
                  (change)="textLowerChange($event, 'title')"
                  [checked]="autoTemplate?.meta?.hasOwnProperty('title_lowercase')">
                <label class="custom-control-label" for="titleLower">lowercase</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isTitleFontChanged"
                  (change)="isTextFontChanged($event, 'title')" [checked]="autoTemplate?.meta?.is_title_font_changed">
                <label class="custom-control-label" for="isTitleFontChanged">Font</label>
              </div>

              <select *ngIf="autoTemplate?.meta?.is_title_font_changed" (change)="textFontChanged($event, 'title')"
                class="form-control bg-dark border-secondary text-light mr-3">
                <option value="">Choose a font</option>
                <option [value]="font.fontName" [selected]="autoTemplate?.meta?.fc_title_font_name == font.fontName"
                  *ngFor="let font of editorService.fancyFonts">
                  {{font.fontDisplayName}} ({{font.copyAndPasteTitleText}})
                </option>
              </select>

              <div *ngIf="autoTemplate?.meta?.is_title_font_changed"
                class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="titleFirstLetter"
                  (change)="textFirstLetterChanged($event, 'title')"
                  [checked]="autoTemplate?.meta?.fc_title_first_letter">
                <label class="custom-control-label" for="titleFirstLetter">First letter</label>
              </div>
            </div>

            <div mwlTextInputHighlightContainer>
              <textarea mwlTextInputElement #videoTitle class="form-control bg-transparent border-secondary text-light"
                id="videoTitle" rows="1" [mentionConfig]="mentionConfig" [ngModel]="autoTemplate?.meta?.title"
                (ngModelChange)="videoTitleChange($event)"></textarea>
              <mwl-text-input-highlight [tags]="highlightTag?.title" [textInputElement]="videoTitle">
              </mwl-text-input-highlight>
            </div>
          </div>

          <div class="form-group">
            <div class="d-flex align-items-center text-truncate mb-2">
              <label class="mr-3 mb-0" for="videoDesc">Description</label>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isDescEmpty"
                  (change)="isTextEmptyChange($event, 'desc')" [checked]="autoTemplate?.meta?.is_desc_empty">
                <label class="custom-control-label" for="isDescEmpty">Empty</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isDescUpper"
                  (change)="isTextUpperChange($event, 'desc')" [checked]="autoTemplate?.meta?.is_desc_upper">
                <label class="custom-control-label" for="isDescUpper">UPPERCASE</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="autoTemplate?.meta?.is_desc_upper && !autoTemplate?.meta?.hasOwnProperty('desc_ucword')">
                <input type="checkbox" class="custom-control-input" id="descCap"
                  (change)="textCapChange($event, 'desc')"
                  [checked]="autoTemplate?.meta?.hasOwnProperty('desc_ucfirst')">
                <label class="custom-control-label" for="descCap">Uppercase Firsts</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="autoTemplate?.meta?.is_desc_upper && !autoTemplate?.meta?.hasOwnProperty('desc_ucfirst') && !autoTemplate?.meta?.hasOwnProperty('desc_lowercase')">
                <input type="checkbox" class="custom-control-input" id="descUpper"
                  (change)="textUpperChange($event, 'desc')"
                  [checked]="autoTemplate?.meta?.hasOwnProperty('desc_ucword')">
                <label class="custom-control-label" for="descUpper">UPPERCASE WORDS</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline"
                *ngIf="!autoTemplate?.meta?.hasOwnProperty('desc_ucword')">
                <input type="checkbox" class="custom-control-input" id="descLower"
                  (change)="textLowerChange($event, 'desc')"
                  [checked]="autoTemplate?.meta?.hasOwnProperty('desc_lowercase')">
                <label class="custom-control-label" for="descLower">lowercase</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isDescFontChanged"
                  (change)="isTextFontChanged($event, 'desc')" [checked]="autoTemplate?.meta?.is_desc_font_changed">
                <label class="custom-control-label" for="isDescFontChanged">Font</label>
              </div>

              <select *ngIf="autoTemplate?.meta?.is_desc_font_changed" (change)="textFontChanged($event, 'desc')"
                class="form-control bg-dark border-secondary text-light mr-3">
                <option value="">Choose a font</option>
                <option [value]="font.fontName" [selected]="autoTemplate?.meta?.fc_desc_font_name == font.fontName"
                  *ngFor="let font of editorService.fancyFonts">
                  {{font.fontDisplayName}} ({{font.copyAndPasteTitleText}})
                </option>
              </select>

              <div *ngIf="autoTemplate?.meta?.is_desc_font_changed"
                class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="descFirstLetter"
                  (change)="textFirstLetterChanged($event, 'desc')"
                  [checked]="autoTemplate?.meta?.fc_desc_first_letter">
                <label class="custom-control-label" for="descFirstLetter">First letter</label>
              </div>
            </div>

            <div mwlTextInputHighlightContainer>
              <textarea mwlTextInputElement #videoDesc class="form-control bg-transparent border-secondary text-light"
                id="videoDesc" rows="5" [mentionConfig]="mentionConfig" [ngModel]="autoTemplate?.meta?.description"
                (ngModelChange)="videoDescChange($event)" (keypress)="videoDescValidate($event)"></textarea>
              <mwl-text-input-highlight [tags]="highlightTag?.description" [textInputElement]="videoDesc">
              </mwl-text-input-highlight>
            </div>
          </div>

          <div class="form-group">
            <div class="d-flex align-items-center text-truncate mb-2">
              <label class="mr-3 mb-0" for="videoTags">Tags</label>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="isTagsEmpty"
                  (change)="isTextEmptyChange($event, 'tags')" [checked]="autoTemplate?.meta?.is_tags_empty">
                <label class="custom-control-label" for="isTagsEmpty">Empty</label>
              </div>
            </div>

            <div mwlTextInputHighlightContainer>
              <textarea mwlTextInputElement #videoTags class="form-control bg-transparent border-secondary text-light"
                id="videoTags" rows="5" [mentionConfig]="mentionConfig" [ngModel]="autoTemplate?.meta?.tags"
                (ngModelChange)="videoTagsChange($event)"></textarea>
              <mwl-text-input-highlight [tags]="highlightTag?.tags" [textInputElement]="videoTags">
              </mwl-text-input-highlight>
            </div>
          </div>

          <div class="custom-control custom-checkbox form-group">
            <input type="checkbox" class="custom-control-input" id="autoUpload"
              [(ngModel)]="autoTemplate.meta.auto_upload">
            <label class="custom-control-label" for="autoUpload">Auto upload</label>
          </div>

          <div class="form-group border border-black rounded p-3" *ngIf="autoTemplate?.meta?.auto_upload">
            <div class="form-group">
              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="schedule" (change)="scheduleChange($event)"
                  [checked]="autoTemplate?.meta?.schedule != null">
                <label class="custom-control-label" for="schedule">Schedules</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input type="checkbox" class="custom-control-input" id="publicX"
                  [(ngModel)]="autoTemplate.meta.public_x">
                <label class="custom-control-label" for="publicX" title="Don't publish or notify subscribers">Public X</label>
              </div>
            </div>

            <div *ngIf="autoTemplate?.meta?.schedule != null">
              <div class="row mb-3" *ngFor="let item of autoTemplate?.meta?.schedule; let i = index">
                <div class="col-md">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Choose a date</mat-label>
                    <input matInput [matDatepicker]="picker" [value]="bindDate(item?.date)"
                      (dateChange)="dateScheduleChange($event, i)">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="col-md">
                  <div class="d-flex align-items-center bg-dark border border-secondary rounded h-100 px-2">
                    <select class="custom-select bg-dark border-0 text-light" (change)="seqTypeChange($event, i)">
                      <option value="">Choose a seq</option>
                      <option [selected]="item?.seq_type == 'daily'" value="daily">Daily</option>
                      <option [selected]="item?.seq_type == 'weekly'" value="weekly">Weekly</option>
                      <option [selected]="item?.seq_type == 'monthly'" value="monthly">Monthly</option>
                    </select>
                    <input type="text" class="form-control bg-dark border-secondary text-light"
                      [ngClass]="{ 'd-none' : item?.seq_type == 'daily' }" [ngModel]="item?.seq_data"
                      (ngModelChange)="seqDataChange($event, i)" (keypress)="validSeqData($event, item?.seq_type)"
                      placeholder="2,3-5" data-toggle="tooltip" data-placement="bottom" title="Weekly (1-7): 1 = Sunday">
                  </div>
                </div>

                <div class="col-md">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-label>Choose time(s)</mat-label>
                    <mat-select (ngModelChange)="timeScheduleChange($event, i)" [ngModel]="autoTemplate?.meta?.schedule[i]?.time_random" [compareWith]="editorService.matCompareWith" multiple>
                      <mat-select-trigger class="text-light">
                        {{ autoTemplate?.meta?.schedule[i]?.time_random?.length ? autoTemplate?.meta?.schedule[i]?.time_random[0] : '' }}
                        <span *ngIf="autoTemplate?.meta?.schedule[i]?.time_random?.length > 1">
                          (+{{ autoTemplate?.meta?.schedule[i]?.time_random.length - 1 }}
                          {{ autoTemplate?.meta?.schedule[i]?.time_random.length == 2 ? 'other' : 'others' }})
                        </span>
                      </mat-select-trigger>

                      <mat-optgroup>
                        <mat-form-field class="w-100">
                          <input matInput placeholder="Search" #timeRangeFilter (keydown)="$event.stopPropagation()">
                        </mat-form-field>
                      </mat-optgroup>

                      <mat-option
                        *ngFor="let t of editorService.getTimeRanges()" [value]="t"
                        [ngClass]="{ 'd-none': !t?.toLowerCase()?.includes(timeRangeFilter.value.toLowerCase()) }">
                        {{ t }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div class="col-md">
                  <select class="custom-select bg-dark border-secondary text-light h-100"
                    (change)="tzScheduleChange($event, i)" disabled>
                    <option>Choose a time zone</option>
                    <option *ngFor="let z of editorService.timeZones" [selected]="item?.time_zone == z.offset"
                      [value]="z.offset">
                      {{ z.country }}</option>
                  </select>
                </div>

                <div class="col-md-1 d-flex align-items-center p-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-trash c-pointer" viewBox="0 0 16 16" (click)="deleteSchedule(i)">
                    <path
                      d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                    <path fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                    class="bi bi-plus c-pointer" viewBox="0 0 16 16" (click)="addSchedule(i)">
                    <path
                      d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                  </svg>
                </div>
              </div>

              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="premiere"
                  [(ngModel)]="autoTemplate.meta.is_premiere">
                <label class="custom-control-label" for="premiere">Set as Premiere</label>
              </div>
            </div>

            <div class="mt-3">
              <mat-form-field appearance="fill">
                <mat-label>Video location</mat-label>
                <mat-select [compareWith]="editorService.matCompareWith" [(ngModel)]="autoTemplate.meta.location">
                  <mat-select-trigger class="text-light">{{ autoTemplate.meta?.location || 'United States' }}</mat-select-trigger>

                  <mat-optgroup>
                    <mat-form-field class="w-100">
                      <input matInput placeholder="Search" #locFilter (keydown)="$event.stopPropagation()">
                    </mat-form-field>
                  </mat-optgroup>

                  <mat-option value="None">None</mat-option>
                  <mat-option *ngFor="let item of editorService.videoLocations" [value]="item"
                    [ngClass]="{ 'd-none': !item?.toLowerCase()?.includes(locFilter.value.toLowerCase()) }">
                    {{ item }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="custom-control custom-checkbox form-group">
            <input type="checkbox" class="custom-control-input" id="autoComment"
              [(ngModel)]="autoTemplate.meta.auto_comment">
            <label class="custom-control-label" for="autoComment">Auto comment</label>
          </div>

          <div class="form-group border border-black rounded p-3" *ngIf="autoTemplate?.meta?.auto_comment">
            <div class="form-group">
              <div class="d-flex align-items-center text-truncate mb-2">
                <label class="mr-3 mb-0" for="comment">Comment</label>

                <div class="custom-control custom-checkbox custom-control-inline">
                  <input type="checkbox" class="custom-control-input" id="isCommentUpper"
                    (change)="isTextUpperChange($event, 'comment')" [checked]="autoTemplate?.meta?.is_comment_upper">
                  <label class="custom-control-label" for="isCommentUpper">UPPERCASE</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline"
                  *ngIf="autoTemplate?.meta?.is_comment_upper && !autoTemplate?.meta?.hasOwnProperty('comment_ucword')">
                  <input type="checkbox" class="custom-control-input" id="commentCap"
                    (change)="textCapChange($event, 'comment')"
                    [checked]="autoTemplate?.meta?.hasOwnProperty('comment_ucfirst')">
                  <label class="custom-control-label" for="commentCap">Uppercase Firsts</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline"
                  *ngIf="autoTemplate?.meta?.is_comment_upper && !autoTemplate?.meta?.hasOwnProperty('comment_ucfirst') && !autoTemplate?.meta?.hasOwnProperty('comment_lowercase')">
                  <input type="checkbox" class="custom-control-input" id="commentUpper"
                    (change)="textUpperChange($event, 'comment')"
                    [checked]="autoTemplate?.meta?.hasOwnProperty('comment_ucword')">
                  <label class="custom-control-label" for="commentUpper">UPPERCASE WORDS</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline"
                  *ngIf="!autoTemplate?.meta?.hasOwnProperty('comment_ucword')">
                  <input type="checkbox" class="custom-control-input" id="commentLower"
                    (change)="textLowerChange($event, 'comment')"
                    [checked]="autoTemplate?.meta?.hasOwnProperty('comment_lowercase')">
                  <label class="custom-control-label" for="commentLower">lowercase</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline">
                  <input type="checkbox" class="custom-control-input" id="isCommentFontChanged"
                    (change)="isTextFontChanged($event, 'comment')"
                    [checked]="autoTemplate?.meta?.is_comment_font_changed">
                  <label class="custom-control-label" for="isCommentFontChanged">Font</label>
                </div>

                <select *ngIf="autoTemplate?.meta?.is_comment_font_changed"
                  (change)="textFontChanged($event, 'comment')"
                  class="form-control bg-dark border-secondary text-light mr-3">
                  <option value="">Choose a font</option>
                  <option [value]="font.fontName" [selected]="autoTemplate?.meta?.fc_comment_font_name == font.fontName"
                    *ngFor="let font of editorService.fancyFonts">
                    {{font.fontDisplayName}} ({{font.copyAndPasteTitleText}})
                  </option>
                </select>

                <div *ngIf="autoTemplate?.meta?.is_comment_font_changed"
                  class="custom-control custom-checkbox custom-control-inline">
                  <input type="checkbox" class="custom-control-input" id="commentFirstLetter"
                    (change)="textFirstLetterChanged($event, 'comment')"
                    [checked]="autoTemplate?.meta?.fc_comment_first_letter">
                  <label class="custom-control-label" for="commentFirstLetter">First letter</label>
                </div>
              </div>

              <div mwlTextInputHighlightContainer>
                <textarea mwlTextInputElement #comment class="form-control bg-transparent border-secondary text-light"
                  id="comment" rows="5" [mentionConfig]="mentionConfig" [ngModel]="autoTemplate?.meta?.comment"
                  (ngModelChange)="commentChange($event)"></textarea>
                <mwl-text-input-highlight [tags]="highlightTag?.comment" [textInputElement]="comment">
                </mwl-text-input-highlight>
              </div>
            </div>

            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="pinComment"
                [(ngModel)]="autoTemplate.meta.is_pin_comment">
              <label class="custom-control-label" for="pinComment">Pin comment</label>
            </div>
          </div>

          <div class="custom-control custom-checkbox form-group">
            <input type="checkbox" class="custom-control-input" id="tiktokAutoUpload"
              [(ngModel)]="autoTemplate.meta.tiktok_auto_upload">
            <label class="custom-control-label" for="tiktokAutoUpload">Auto TikTok upload</label>
          </div>

          <div class="form-group border border-black rounded p-3" *ngIf="autoTemplate?.meta?.tiktok_auto_upload">
            <div class="form-group">
              <label for="tiktokAccount">Account</label>
              <input [(ngModel)]="autoTemplate.meta.tiktok_account" placeholder="example@gmail.com" type="text"
                class="form-control bg-dark border-secondary text-light" id="tiktokAccount">
            </div>

            <div class="form-group">
              <div class="d-flex align-items-center text-truncate mb-2">
                <label class="mr-3 mb-0" for="tiktokTitle">Title</label>

                <div class="custom-control custom-checkbox custom-control-inline">
                  <input type="checkbox" class="custom-control-input" id="isTiktokTitleUpper"
                    (change)="isTextUpperChange($event, 'tiktok_title')"
                    [checked]="autoTemplate?.meta?.is_tiktok_title_upper">
                  <label class="custom-control-label" for="isTiktokTitleUpper">UPPERCASE</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline"
                  *ngIf="autoTemplate?.meta?.is_tiktok_title_upper && !autoTemplate?.meta?.hasOwnProperty('tiktok_title_ucword')">
                  <input type="checkbox" class="custom-control-input" id="tiktokTitleCap"
                    (change)="textCapChange($event, 'tiktok_title')"
                    [checked]="autoTemplate?.meta?.hasOwnProperty('tiktok_title_ucfirst')">
                  <label class="custom-control-label" for="tiktokTitleCap">Uppercase Firsts</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline"
                  *ngIf="autoTemplate?.meta?.is_tiktok_title_upper && !autoTemplate?.meta?.hasOwnProperty('tiktok_title_ucfirst') && !autoTemplate?.meta?.hasOwnProperty('tiktok_title_lowercase')">
                  <input type="checkbox" class="custom-control-input" id="tiktokTitleUpper"
                    (change)="textUpperChange($event, 'tiktok_title')"
                    [checked]="autoTemplate?.meta?.hasOwnProperty('tiktok_title_ucword')">
                  <label class="custom-control-label" for="tiktokTitleUpper">UPPERCASE WORDS</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline"
                  *ngIf="!autoTemplate?.meta?.hasOwnProperty('tiktok_title_ucword')">
                  <input type="checkbox" class="custom-control-input" id="tiktokTitleLower"
                    (change)="textLowerChange($event, 'tiktok_title')"
                    [checked]="autoTemplate?.meta?.hasOwnProperty('tiktok_title_lowercase')">
                  <label class="custom-control-label" for="tiktokTitleLower">lowercase</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline">
                  <input type="checkbox" class="custom-control-input" id="isTiktokTitleFontChanged"
                    (change)="isTextFontChanged($event, 'tiktok_title')"
                    [checked]="autoTemplate?.meta?.is_tiktok_title_font_changed">
                  <label class="custom-control-label" for="isTiktokTitleFontChanged">Font</label>
                </div>

                <select *ngIf="autoTemplate?.meta?.is_tiktok_title_font_changed"
                  (change)="textFontChanged($event, 'tiktok_title')"
                  class="form-control bg-dark border-secondary text-light mr-3">
                  <option value="">Choose a font</option>
                  <option [value]="font.fontName"
                    [selected]="autoTemplate?.meta?.fc_tiktok_title_font_name == font.fontName"
                    *ngFor="let font of editorService.fancyFonts">
                    {{font.fontDisplayName}} ({{font.copyAndPasteTitleText}})
                  </option>
                </select>

                <div *ngIf="autoTemplate?.meta?.is_tiktok_title_font_changed"
                  class="custom-control custom-checkbox custom-control-inline">
                  <input type="checkbox" class="custom-control-input" id="tiktokTitleFirstLetter"
                    (change)="textFirstLetterChanged($event, 'tiktok_title')"
                    [checked]="autoTemplate?.meta?.fc_tiktok_title_first_letter">
                  <label class="custom-control-label" for="tiktokTitleFirstLetter">First letter</label>
                </div>
              </div>

              <div mwlTextInputHighlightContainer>
                <textarea mwlTextInputElement #tiktokTitle
                  class="form-control bg-transparent border-secondary text-light" id="tiktokTitle" rows="1"
                  [mentionConfig]="mentionConfig" [ngModel]="autoTemplate?.meta?.tiktok_title"
                  (ngModelChange)="tiktokTitleChange($event)"></textarea>
                <mwl-text-input-highlight [tags]="highlightTag?.tiktok_title" [textInputElement]="tiktokTitle">
                </mwl-text-input-highlight>
              </div>
            </div>

            <div class="form-group">
              <div class="d-flex align-items-center text-truncate mb-2">
                <label class="mr-3 mb-0" for="tiktokDesc">Description</label>

                <div class="custom-control custom-checkbox custom-control-inline">
                  <input type="checkbox" class="custom-control-input" id="isTiktokDescUpper"
                    (change)="isTextUpperChange($event, 'tiktok_desc')"
                    [checked]="autoTemplate?.meta?.is_tiktok_desc_upper">
                  <label class="custom-control-label" for="isTiktokDescUpper">UPPERCASE</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline"
                  *ngIf="autoTemplate?.meta?.is_tiktok_desc_upper && !autoTemplate?.meta?.hasOwnProperty('tiktok_desc_ucword')">
                  <input type="checkbox" class="custom-control-input" id="tiktokDescCap"
                    (change)="textCapChange($event, 'tiktok_desc')"
                    [checked]="autoTemplate?.meta?.hasOwnProperty('tiktok_desc_ucfirst')">
                  <label class="custom-control-label" for="tiktokDescCap">Uppercase Firsts</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline"
                  *ngIf="autoTemplate?.meta?.is_tiktok_desc_upper && !autoTemplate?.meta?.hasOwnProperty('tiktok_desc_ucfirst') && !autoTemplate?.meta?.hasOwnProperty('tiktok_desc_lowercase')">
                  <input type="checkbox" class="custom-control-input" id="tiktokDescUpper"
                    (change)="textUpperChange($event, 'tiktok_desc')"
                    [checked]="autoTemplate?.meta?.hasOwnProperty('tiktok_desc_ucword')">
                  <label class="custom-control-label" for="tiktokDescUpper">UPPERCASE WORDS</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline"
                  *ngIf="!autoTemplate?.meta?.hasOwnProperty('tiktok_desc_ucword')">
                  <input type="checkbox" class="custom-control-input" id="tiktokDescLower"
                    (change)="textLowerChange($event, 'tiktok_desc')"
                    [checked]="autoTemplate?.meta?.hasOwnProperty('tiktok_desc_lowercase')">
                  <label class="custom-control-label" for="tiktokDescLower">lowercase</label>
                </div>

                <div class="custom-control custom-checkbox custom-control-inline">
                  <input type="checkbox" class="custom-control-input" id="isTiktokDescFontChanged"
                    (change)="isTextFontChanged($event, 'tiktok_desc')"
                    [checked]="autoTemplate?.meta?.is_tiktok_desc_font_changed">
                  <label class="custom-control-label" for="isTiktokDescFontChanged">Font</label>
                </div>

                <select *ngIf="autoTemplate?.meta?.is_tiktok_desc_font_changed"
                  (change)="textFontChanged($event, 'tiktok_desc')"
                  class="form-control bg-dark border-secondary text-light mr-3">
                  <option value="">Choose a font</option>
                  <option [value]="font.fontName"
                    [selected]="autoTemplate?.meta?.fc_tiktok_desc_font_name == font.fontName"
                    *ngFor="let font of editorService.fancyFonts">
                    {{font.fontDisplayName}} ({{font.copyAndPasteTitleText}})
                  </option>
                </select>

                <div *ngIf="autoTemplate?.meta?.is_tiktok_desc_font_changed"
                  class="custom-control custom-checkbox custom-control-inline">
                  <input type="checkbox" class="custom-control-input" id="tiktokDescFirstLetter"
                    (change)="textFirstLetterChanged($event, 'tiktok_desc')"
                    [checked]="autoTemplate?.meta?.fc_tiktok_desc_first_letter">
                  <label class="custom-control-label" for="tiktokDescFirstLetter">First letter</label>
                </div>
              </div>

              <div mwlTextInputHighlightContainer>
                <textarea mwlTextInputElement #tiktokDesc
                  class="form-control bg-transparent border-secondary text-light" id="tiktokDesc" rows="1"
                  [mentionConfig]="mentionConfig" [ngModel]="autoTemplate?.meta?.tiktok_desc"
                  (ngModelChange)="tiktokDescChange($event)"></textarea>
                <mwl-text-input-highlight [tags]="highlightTag?.tiktok_desc" [textInputElement]="tiktokDesc">
                </mwl-text-input-highlight>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md">
                <label>Start time (h:m:s)</label>
                <div class="input-group">
                  <input [(ngModel)]="autoTemplate.meta.tiktok_start_time_hours" min="0" type="number"
                    class="form-control bg-dark border-secondary text-light">
                  <input [(ngModel)]="autoTemplate.meta.tiktok_start_time_minutes" min="0" type="number"
                    class="form-control bg-dark border-secondary text-light">
                  <input [(ngModel)]="autoTemplate.meta.tiktok_start_time_seconds" min="0" type="number"
                    class="form-control bg-dark border-secondary text-light">
                </div>
              </div>

              <div class="form-group col-md">
                <label>Duration (h:m:s)</label>
                <div class="input-group">
                  <input [(ngModel)]="autoTemplate.meta.tiktok_duration_hours" min="0" type="number"
                    class="form-control bg-dark border-secondary text-light">
                  <input [(ngModel)]="autoTemplate.meta.tiktok_duration_minutes" min="0" type="number"
                    class="form-control bg-dark border-secondary text-light">
                  <input [(ngModel)]="autoTemplate.meta.tiktok_duration_seconds" min="0" type="number"
                    class="form-control bg-dark border-secondary text-light">
                </div>
              </div>
            </div>

            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="tiktokTranspose"
                [(ngModel)]="autoTemplate.meta.tiktok_transpose">
              <label class="custom-control-label" for="tiktokTranspose">Transpose</label>
            </div>
          </div>

          <div class="custom-control custom-checkbox form-group">
            <input type="checkbox" class="custom-control-input" id="autoCard" [(ngModel)]="autoCardEnabled">
            <label class="custom-control-label" for="autoCard">Auto cards</label>
          </div>

          <div *ngIf="autoTemplate?.meta?.auto_card" class="form-group border border-black rounded p-3">
            <div class="form-group">
              <label for="autoCardVideoId">Video ID</label>
              <input [(ngModel)]="autoTemplate.meta.auto_card.target_video_id"
                (change)="autoTemplate.meta.auto_card.target_video_id = parseYoutubeId($event)" type="text"
                class="form-control bg-dark border-secondary text-light" id="autoCardVideoId">
            </div>
          </div>

          <div class="custom-control custom-checkbox form-group">
            <input type="checkbox" class="custom-control-input" id="autoEndscreen"
              [(ngModel)]="autoEndscreenEnabled">
            <label class="custom-control-label" for="autoEndscreen">Auto endscreen</label>
          </div>

          <div *ngIf="autoTemplate?.meta?.auto_endscreen" class="form-group border border-black rounded p-3">
            <div class="row mb-3">
              <div class="col-md-2">
                <div class="border border-primary rounded d-flex align-items-center justify-content-center"
                  style="aspect-ratio:16/9;padding:1rem;">
                  <div class="bg-secondary rounded" style="width:64px;height:36px;"></div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="autoEndscreenVideoId">Video ID</label>
              <input [(ngModel)]="autoTemplate.meta.auto_endscreen.target_video_id"
                (change)="autoTemplate.meta.auto_endscreen.target_video_id = parseYoutubeId($event)" type="text"
                class="form-control bg-dark border-secondary text-light" id="autoEndscreenVideoId">
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div *ngIf="templateType == 'saveHub' && hubLog" class="d-flex align-items-start flex-grow-1 mr-2">
          <button type="button" class="btn btn-sm btn-link text-light px-1" (click)="refreshHubLog()"
            [disabled]="isLoadingHubLog" data-toggle="tooltip" data-placement="top" title="Refresh log"
            aria-label="Refresh log">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
              class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
              <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
            </svg>
          </button>
          <textarea class="form-control form-control-sm text-monospace bg-dark border-secondary text-light" rows="1"
            wrap="off" readonly [value]="hubLog"></textarea>
        </div>

        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary"
          (click)="templateType == 'newTemplate' ? saveNewTemplate($event) : templateType == 'saveTemplate' || templateType == 'isSavedTemplate' ? saveTemplate($event) : templateType == 'newHub' ? saveNewHub($event) : saveHub($event)">
          Save
        </button>
        <button *ngIf="templateType == 'saveHub'" type="button" class="btn btn-danger" (click)="saveHub('rerender')">
          Save & Rerender
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" tabindex="-1" id="lyricModal">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Lyrics</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="mb-3">
          <div class="custom-control custom-radio custom-control-inline">
            <input type="radio" id="deezerSource" name="lyricSource" class="custom-control-input"
              [(ngModel)]="lyricSource" value="deezer">
            <label class="custom-control-label" for="deezerSource">Deezer</label>
          </div>

          <div class="custom-control custom-radio custom-control-inline">
            <input type="radio" id="localSource" name="lyricSource" class="custom-control-input"
              [(ngModel)]="lyricSource" value="local">
            <label class="custom-control-label" for="localSource">Local</label>
          </div>
        </div>

        <div class="input-group mb-3">
          <input type="text" class="form-control bg-dark border-secondary text-light" #typing
            [placeholder]="lyricSource == 'deezer' ? 'deezer id' : 'local id'"
            (keyup.enter)="lyricSearchChange(typing.value)">
          <div class="input-group-append">
            <button class="btn btn-secondary" type="button" (click)="lyricSearchChange(typing.value)">Search</button>
          </div>
        </div>

        <ul class="list-group list-group-flush" *ngIf="lyricList?.length > 0; else elseBlock2">
          <li class="list-group-item list-group-item-action bg-dark text-light px-0" *ngFor="let item of lyricList">
            <div class="d-flex justify-content-between align-items-center">
              {{ item?.title }} - {{ item?.artist }}
              <button *ngIf="!item.highlights?.length" type="button" class="btn btn-outline-primary btn-sm" (click)="selectedLyric(item)">Select</button>
            </div>

            <div *ngIf="item.highlights?.length" class="mt-3">
              <div *ngFor="let highlight of item.highlights" class="d-flex align-items-center py-1 px-2 mb-1 bg-gray-700 rounded">
                <button 
                  type="button" 
                  class="btn btn-sm btn-link text-light p-0 mr-2"
                  (click)="isPlaying(highlight) ? stopHighlight() : playHighlight(item, highlight)"
                  style="width: 24px; height: 24px;">

                  <svg *ngIf="isPlaying(highlight)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-pause" viewBox="0 0 16 16">
                    <path d="M6 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5m4 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5"/>
                  </svg>

                  <svg *ngIf="!isPlaying(highlight)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-play" viewBox="0 0 16 16">
                    <path d="M10.804 8 5 4.633v6.734zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696z"/>
                  </svg>
                </button>

                <span class="flex-grow-1 mr-2">{{ highlight.section_name }}</span>

                <small class="text-white-50 mr-2">
                  {{ ((highlight.end_ms - highlight.start_ms) / 1000).toFixed(1) }}s
                </small>

                <span class="badge bg-warning text-dark mr-4">P{{ highlight.priority }}</span>

                <button type="button" class="btn btn-outline-primary btn-sm" (click)="selectedLyric(item, highlight)">Select</button>
              </div>
            </div>
          </li>
        </ul>
        <ng-template #elseBlock2>Search results will appear here</ng-template>

        <div class="d-flex justify-content-center" *ngIf="isLoading">
          <img src="/assets/images/loading.gif" width="50">
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" tabindex="-1" id="clearStorage">
  <div class="modal-dialog">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Clear storage</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <p>Are you sure to clear storage of <span class="text-danger font-weight-bold">{{ channel?.name }}</span>?</p>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="clearStorage()">Clear</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" tabindex="-1" id="chooseChannel">
  <div class="modal-dialog">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Channels</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <ul class="list-group list-group-flush" *ngIf="channelList?.length > 0">
          <li class="list-group-item list-group-item-action bg-dark text-light" *ngFor="let item of channelList.slice(0, 10)">
            <div class="d-flex justify-content-between align-items-center">
              {{ item?.chanel_name }}
              <button type="button" class="btn btn-outline-primary btn-sm"
                (click)="selectedChannel(item)">Select</button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="envModal">
  <div class="modal-dialog modal-dialog-scrollable modal-lg">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Environment variables</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <button *ngIf="!controlType.includes('collection:env') && currentHub.id != null && currentHub.id != -1"
          (click)="btnExtendEnv()" type="button" class="btn btn-primary mb-3">
          Extend Env
        </button>

        <ng-container *ngFor="let item of autoTemplate?.env; let i = index">
          <div class="form-row align-items-baseline">
            <div class="form-group col-md-4">
              <input type="text" class="form-control bg-dark border-secondary text-light" placeholder="Variable name"
                [ngModel]="item?.name" (ngModelChange)="varNameChange($event, i)" (keypress)="validVarName($event)"
                [disabled]="item?.code == 'collection'">
            </div>

            <div class="form-group col-md">
              <div mwlTextInputHighlightContainer class="mb-2">
                <textarea mwlTextInputElement #varValue class="form-control bg-transparent border-secondary text-light"
                  placeholder="Variable value" rows="1" [mentionConfig]="mentionConfig" [ngModel]="item?.value"
                  (ngModelChange)="varValueChange($event, i)" [disabled]="item?.code == 'collection'"></textarea>
                <mwl-text-input-highlight
                  [tags]="highlightEnv.hasOwnProperty(item?.name) ? highlightEnv[item?.name] : []"
                  [textInputElement]="varValue">
                </mwl-text-input-highlight>
              </div>

              <div class="form-group">
                <div class="custom-control custom-checkbox custom-control-inline">
                  <input [ngModel]="fancyFont['is_env_' + item?.name]" (ngModelChange)="isEnvFontChanged($event, i)"
                    type="checkbox" class="custom-control-input" [id]="'isEnvFontChanged' + i">
                  <label class="custom-control-label" [attr.for]="'isEnvFontChanged' + i">Font</label>
                </div>

                <div *ngIf="fancyFont['is_env_' + item?.name]"
                  class="custom-control custom-checkbox custom-control-inline">
                  <input [(ngModel)]="fancyFont['env_' + item?.name + '_first_letter']" type="checkbox"
                    class="custom-control-input" [id]="'envFirstLetter' + i">
                  <label class="custom-control-label" [attr.for]="'envFirstLetter' + i">First letter</label>
                </div>
              </div>

              <div *ngIf="fancyFont['is_env_' + item?.name]" class="form-group">
                <mat-form-field appearance="fill" class="w-100">
                  <mat-label>Choose fonts</mat-label>

                  <mat-select [(ngModel)]="fancyFont['env_' + item?.name + '_fonts']" [compareWith]="editorService.matCompareWith"
                    multiple>
                    <mat-select-trigger class="text-light">
                      {{ fancyFont['env_' + item?.name + '_fonts']?.length ? fancyFont['env_' + item?.name +
                      '_fonts'][0].fontDisplayName : '' }}
                      <span *ngIf="fancyFont['env_' + item?.name + '_fonts']?.length > 1">
                        (+{{ fancyFont['env_' + item?.name + '_fonts'].length - 1 }}
                        {{ fancyFont['env_' + item?.name + '_fonts'].length == 2 ? 'other' : 'others' }})
                      </span>
                    </mat-select-trigger>

                    <mat-optgroup>
                      <mat-form-field class="w-100">
                        <input matInput placeholder="Search" #fontFilter (keydown)="$event.stopPropagation()">
                      </mat-form-field>
                    </mat-optgroup>

                    <mat-option *ngFor="let f of editorService.fancyFonts"
                      [ngClass]="{ 'd-none': !f.fontName.includes(fontFilter.value.toLowerCase()) }" [value]="f">
                      {{ f.fontDisplayName }} ({{ f.copyAndPasteTitleText }})
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <button *ngIf="fancyFont['is_env_' + item?.name]" (click)="envApplyClicked($event, i)" type="button"
                class="btn btn-sm btn-secondary">Apply</button>
            </div>

            <div class="form-group col-md-1 d-flex align-items-center justify-content-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-trash c-pointer" viewBox="0 0 16 16" (click)="deleteVar(i)">
                <path
                  d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                <path fill-rule="evenodd"
                  d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                class="bi bi-plus c-pointer" viewBox="0 0 16 16" (click)="addVar()">
                <path
                  d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
              </svg>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="saveEnv($event)">Save changes</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" tabindex="-1" id="modal-spinner">
  <div class="modal-dialog modal-80">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Spinner</h5>
        <button type="button" class="close" data-dismiss="modal" (click)="spinnerClear()">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <ul class="nav nav-pills" id="hubTab" role="tablist">
          <li class="nav-item" role="presentation">
            <a class="nav-link active" data-toggle="tab" href="#source" role="tab">Step 1 - Source</a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" data-toggle="tab" href="#spin" role="tab" (click)="processSpinText()">Step 2 - Make
              spin</a>
          </li>
        </ul>

        <div class="tab-content mt-3" id="hubTabContent">
          <div class="tab-pane fade show active" id="source" role="tabpanel">
            <div class="form-group">
              <textarea class="form-control bg-dark border-secondary text-light" id="spinText" rows="20" cols="30"
                spellcheck="false" placeholder="Column data"></textarea>
            </div>
          </div>

          <div class="tab-pane fade show" id="spin" role="tabpanel">
            <div class="row">
              <div class="col-md-12 mb-2">
                <!-- <svg (click)="spinnerChange('down')" data-toggle="tooltip" data-placement="top" title="Down" xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-arrow-bar-down float-right mr-2 c-pointer" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5zM8 6a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 .708-.708L7.5 12.293V6.5A.5.5 0 0 1 8 6z"/>
                </svg>
                <svg  (click)="spinnerChange('up')" data-toggle="tooltip" data-placement="top" title="Up" xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-arrow-bar-up float-right mr-2 c-pointer" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 10a.5.5 0 0 0 .5-.5V3.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 3.707V9.5a.5.5 0 0 0 .5.5zm-7 2.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5z"/>
                </svg> -->
                <svg (click)="spinnerChange('show')" data-toggle="tooltip" data-placement="top" title="Show/hide"
                  xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                  class="bi bi-eye-fill float-right mr-2 c-pointer" viewBox="0 0 16 16">
                  <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                  <path
                    d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                </svg>
                <svg (click)="spinnerChange('ungroup')" data-toggle="tooltip" data-placement="top" title="Ungroup"
                  xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                  class="bi bi-arrows-collapse float-right mr-2 c-pointer" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zM7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708l2-2zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10z" />
                </svg>
                <svg (click)="spinnerChange('group')" data-toggle="tooltip" data-placement="top" title="Group"
                  xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                  class="bi bi-arrows-collapse float-right mr-2 c-pointer" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 8zm7-8a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 4.293V.5A.5.5 0 0 1 8 0zm-.5 11.707-1.146 1.147a.5.5 0 0 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 11.707V15.5a.5.5 0 0 1-1 0v-3.793z" />
                </svg>
              </div>
            </div>

            <div id="spinner-content" class="row justify-content-center">
              <div *ngFor="let item of spinnerJsonSource" class="col-md-1 mr-2 spinner-{{item?.id}}"
                [ngStyle]="{ 'background': item?.color, 'min-height': '300px' }" attr.dataId="{{item?.id}}"
                attr.colorId="{{item?.id}}">

                <input type="checkbox" class="check-{{item?.id}} spinner-check-tr" value="{{item?.id}}"
                  (change)="spinnerCheckGroup($event)">
                <ul class="p-1 c-pointer" style="z-index: 10000">
                  <span stype="z-index: 1" *ngFor="let data of item?.data;let j = index">
                    <li [ngStyle]="{ 'overflow': 'hidden'}" *ngIf="data != '' && j <  5"><span>{{data}}</span></li>
                  </span>
                </ul>

                <div class="spinner-toolbar-{{item?.id}} ">
                  <svg (click)="spinChangeLevelDown(item?.id)" data-toggle="tooltip" data-placement="top"
                    title="Level down" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-arrow-bar-down smallControlButtonIcon spinner-item-bl" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5zM8 6a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 .708-.708L7.5 12.293V6.5A.5.5 0 0 1 8 6z" />
                  </svg>
                  <svg (click)="spinChangeLevelUp(item?.id)" data-toggle="tooltip" data-placement="top" title="Level up"
                    xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-arrow-bar-up smallControlButtonIcon spinner-item-br" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M8 10a.5.5 0 0 0 .5-.5V3.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 3.707V9.5a.5.5 0 0 0 .5.5zm-7 2.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5z" />
                  </svg>
                  <svg (click)="spinShowHide(item?.id)" data-toggle="tooltip" data-placement="top" title="Show/hide"
                    xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-eye-fill smallControlButtonIcon spinner-item-tl" viewBox="0 0 16 16">
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                    <path
                      d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                  </svg>
                  <svg attr.dataId="{{item?.id}}" data-toggle="tooltip" data-placement="top" title="Change Group"
                    attr.colorId="{{item?.id}}" (click)="spinGroupping($event)" xmlns="http://www.w3.org/2000/svg"
                    width="16" height="16" fill="currentColor"
                    class="bi bi-braces smallControlButtonIcon spinner-item-tr" viewBox="0 0 16 16">
                    <path
                      d="M2.114 8.063V7.9c1.005-.102 1.497-.615 1.497-1.6V4.503c0-1.094.39-1.538 1.354-1.538h.273V2h-.376C3.25 2 2.49 2.759 2.49 4.352v1.524c0 1.094-.376 1.456-1.49 1.456v1.299c1.114 0 1.49.362 1.49 1.456v1.524c0 1.593.759 2.352 2.372 2.352h.376v-.964h-.273c-.964 0-1.354-.444-1.354-1.538V9.663c0-.984-.492-1.497-1.497-1.6zM13.886 7.9v.163c-1.005.103-1.497.616-1.497 1.6v1.798c0 1.094-.39 1.538-1.354 1.538h-.273v.964h.376c1.613 0 2.372-.759 2.372-2.352v-1.524c0-1.094.376-1.456 1.49-1.456V7.332c-1.114 0-1.49-.362-1.49-1.456V4.352C13.51 2.759 12.75 2 11.138 2h-.376v.964h.273c.964 0 1.354.444 1.354 1.538V6.3c0 .984.492 1.497 1.497 1.6z" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer flex-nowrap">
        <svg (click)="spinConvert()" data-toggle="tooltip" data-placement="top" title="Make spin"
          xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="currentColor"
          class="bi bi-arrow-right-square c-pointer" viewBox="0 0 16 16">
          <path fill-rule="evenodd"
            d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm4.5 5.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
        </svg>
        <textarea #textCopy class="form-control bg-dark border-secondary text-muted" id="spinner-result"
          spellcheck="false" placeholder="Pattern"></textarea>
        <textarea class="form-control bg-dark border-secondary text-muted" id="spinner-example" spellcheck="false"
          placeholder="Example"></textarea>
        <svg [ngxClipboard]="textCopy" (click)="spinCopyToClipboard()" data-toggle="tooltip" data-placement="top"
          title="Copy" xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="currentColor"
          class="bi bi-clipboard c-pointer" viewBox="0 0 16 16">
          <path
            d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
          <path
            d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
        </svg>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="metaModal" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Meta</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label for="videoTitle">Title</label>
          <div class="d-flex align-items-center">
            <textarea #titleCopy class="form-control bg-dark border-secondary text-light" id="videoTitle" rows="1"
              [ngModel]="testJob?.meta?.title"></textarea>
            <button type="button" class="btn btn-link" [ngxClipboard]="titleCopy">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-clipboard"
                viewBox="0 0 16 16" data-toggle="tooltip" data-placement="top" title="Copy">
                <path
                  d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                <path
                  d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
              </svg>
            </button>
          </div>
        </div>
        <div class="form-group">
          <label for="videoDesc">Description</label>
          <div class="d-flex align-items-center">
            <textarea #descCopy class="form-control bg-dark border-secondary text-light" id="videoDesc" rows="5"
              [ngModel]="testJob?.meta?.description"></textarea>
            <button type="button" class="btn btn-link" [ngxClipboard]="descCopy">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-clipboard"
                viewBox="0 0 16 16" data-toggle="tooltip" data-placement="top" title="Copy">
                <path
                  d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                <path
                  d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
              </svg>
            </button>
          </div>
        </div>
        <div class="form-group">
          <label for="videoTags">Tags</label>
          <div class="d-flex align-items-center">
            <textarea #tagCopy class="form-control bg-dark border-secondary text-light" id="videoTags" rows="5"
              [ngModel]="testJob?.meta?.tags"></textarea>
            <button type="button" class="btn btn-link" [ngxClipboard]="tagCopy">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-clipboard"
                viewBox="0 0 16 16" data-toggle="tooltip" data-placement="top" title="Copy">
                <path
                  d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                <path
                  d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
              </svg>
            </button>
          </div>
        </div>
        <p>* <strong>Compilation</strong> hub, variables <span
            class="badge badge-pill badge-primary">@@song_list_all@@</span>, <span
            class="badge badge-pill badge-primary">@@song_name_all@@</span>, <span
            class="badge badge-pill badge-primary">@@artist_name_x@@</span>... will be replaced when rendering video.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="helpModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-scrollable modal-lg">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Help</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <ul class="nav nav-pills" id="helpTab" role="tablist">
          <li class="nav-item" role="presentation">
            <a class="nav-link active" data-toggle="pill" href="#globalVariables" role="tab">Global variables</a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" data-toggle="pill" href="#releaseNotes" role="tab">Release notes</a>
          </li>
          <li *ngIf="['sangmusic', 'tungtt', 'hieumusic'].includes(username)" class="nav-item" role="presentation">
            <a class="nav-link" data-toggle="pill" href="#tools" role="tab">Tools</a>
          </li>
        </ul>

        <div class="tab-content" id="helpTabContent">
          <div class="tab-pane fade show active" id="globalVariables" role="tabpanel">
            <ul class="list-group list-group-flush" *ngIf="langCodeList.length">
              <ng-container *ngFor="let item of langCodeList">
                <li class="list-group-item bg-dark text-light" *ngIf="!item?.code?.includes('env')"><span
                    class="badge badge-pill badge-primary">{{ item?.code }}</span> {{ item?.note }}</li>
              </ng-container>
            </ul>
          </div>

          <div class="tab-pane fade" id="releaseNotes" role="tabpanel"></div>

          <div *ngIf="['sangmusic', 'tungtt', 'hieumusic'].includes(username)" class="tab-pane fade" id="tools"
            role="tabpanel">
            <div class="pt-3">
              <label>Clone channel</label>

              <div class="form-row">
                <div class="form-group col-md">
                  <input [(ngModel)]="tools.clone_channel.source_id" type="text" list="channels"
                    class="form-control bg-dark border-secondary text-light" placeholder="Source channel id">
                </div>

                <div class="form-group col-md">
                  <input [(ngModel)]="tools.clone_channel.target_id" type="text" list="channels"
                    class="form-control bg-dark border-secondary text-light" placeholder="Target channel id">
                </div>

                <div class="form-group col-md">
                  <input [(ngModel)]="tools.clone_channel.target_name" type="text"
                    class="form-control bg-dark border-secondary text-light" placeholder="Target channel name (Optional)">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button *ngIf="tools.clone_channel.source_id && tools.clone_channel.target_id" (click)="cloneChannel($event)"
          type="button" class="btn btn-primary">
          <span *ngIf="tools.clone_channel.is_loading" class="spinner-border spinner-border-sm" role="status"></span>
          Clone
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="collectionModal" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-scrollable modal-xxl">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Collection</h5>
        <button (click)="closeCollection()" type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body mx-n2">
        <div class="btn-toolbar justify-content-between mb-3 mx-2" role="toolbar">
          <div role="group">
            <button (click)="btnNewCollection()" type="button" class="btn btn-outline-secondary text-light mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-folder-plus" viewBox="0 0 16 16">
                <path d="m.5 3 .04.87a1.99 1.99 0 0 0-.342 1.311l.637 7A2 2 0 0 0 2.826 14H9v-1H2.826a1 1 0 0 1-.995-.91l-.637-7A1 1 0 0 1 2.19 4h11.62a1 1 0 0 1 .996 1.09L14.54 8h1.005l.256-2.819A2 2 0 0 0 13.81 3H9.828a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 6.172 1H2.5a2 2 0 0 0-2 2zm5.672-1a1 1 0 0 1 .707.293L7.586 3H2.19c-.24 0-.47.042-.683.12L1.5 2.98a1 1 0 0 1 1-.98h3.672z" />
                <path d="M13.5 10a.5.5 0 0 1 .5.5V12h1.5a.5.5 0 1 1 0 1H14v1.5a.5.5 0 1 1-1 0V13h-1.5a.5.5 0 0 1 0-1H13v-1.5a.5.5 0 0 1 .5-.5z" />
              </svg>
              New
            </button>

            <button *ngIf="currentCollection.hasOwnProperty('type')" (click)="cloneCollection()" type="button"
              class="btn btn-outline-secondary text-light mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files"
                viewBox="0 0 16 16">
                <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z" />
              </svg>
              Clone
            </button>

            <ng-container *ngIf="currentCollection.hasOwnProperty('type') && currentCollection.user == username">
              <button (click)="btnEditCollection()" type="button" class="btn btn-outline-secondary text-light mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-pencil-square" viewBox="0 0 16 16">
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                </svg>
                Edit
              </button>

              <button [disabled]="collectionData.isExtend" *ngIf="currentCollection?.type < 5"
                (click)="btnUpdateCollection()" type="button" class="btn btn-outline-secondary text-light">
                <svg *ngIf="currentCollection?.type < 3" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  fill="currentColor" class="bi bi-file-earmark-arrow-up" viewBox="0 0 16 16">
                  <path d="M8.5 11.5a.5.5 0 0 1-1 0V7.707L6.354 8.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 7.707V11.5z" />
                  <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                </svg>

                <svg *ngIf="currentCollection?.type > 2" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                  fill="currentColor" class="bi bi-sliders" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3h9.05zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8h2.05zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1h9.05z" />
                </svg>
                {{ currentCollection?.type < 3 ? 'Upload' : 'Config' }}
              </button>
            </ng-container>
          </div>

          <div role="group" class="d-flex align-items-center">
            <div class="input-group mr-2">
              <input (keyup.enter)="collectionSearch(collectionInput.value)" #collectionInput type="text"
                class="form-control bg-dark border-secondary text-light" placeholder="Search id, name">

              <div *ngIf="collectionInput.value" (click)="collectionInput.value = ''; reloadCollection()" role="button" class="input-group-append">
                <span class="input-group-text bg-dark border-secondary text-light border-left-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg"
                    viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z" />
                    <path fill-rule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z" />
                  </svg>
                </span>
              </div>
            </div>

            <select [disabled]="collectionData.isExtend" [ngModel]="collectionData.filterGroup"
              (ngModelChange)="filterGroupChange($event)"
              class="custom-select bg-dark border-secondary text-light w-auto mr-2">
              <option value="">Group</option>
              <option value="all">All</option>
              <option value="user">My User</option>
              <option value="share">Share</option>
              <option value="company">Company</option>
            </select>

            <select [disabled]="collectionData.isExtend" [ngModel]="collectionData.filterType"
              (ngModelChange)="filterTypeChange($event)"
              class="custom-select bg-dark border-secondary text-light w-auto mr-2">
              <option value="">Filter</option>
              <option value="1">Image</option>
              <option value="2">Video</option>
              <option value="4">Env</option>
              <option value="8">Super</option>
              <option value="5">TikTok</option>
              <option value="7">Shorts</option>
              <option value="3">Music</option>
              <option value="6">YouTube</option>
              <option value="outdated">Outdated</option>
            </select>

            <button (click)="reloadCollection()" type="button" class="btn btn-outline-secondary text-light">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
              </svg>
              Reload
            </button>
          </div>
        </div>

        <div class="accordion" id="accordionCollection">
          <div class="mb-3">
            <div *ngIf="!collectionData.results.length" class="text-center py-2" role="status">
              <ng-container *ngIf="collectionData.isLoading">
                <span class="spinner-border spinner-border-sm mr-2"></span> Loading...
              </ng-container>
              <span *ngIf="!collectionData.isLoading && collectionData.hasError" class="text-danger">
                Could not load collections, press Reload to try again
              </span>
              <ng-container *ngIf="!collectionData.isLoading && !collectionData.hasError">No available data</ng-container>
            </div>

            <div *ngFor="let collection of collectionData.results" class="btn-group m-2" role="group">
              <button
                [ngClass]="{ 'btn-primary': collection?.id == currentCollection?.id || linkedCollection(collection?.id), 'btn-secondary': collection?.id == currentCollection?.id && !linkedCollection(collection?.id), 'btn-outline-secondary': collection?.id != currentCollection?.id && !linkedCollection(collection?.id) }"
                (click)="currentCollection = collection" (dblclick)="collectionToggle(collection)"
                class="btn text-light" type="button">
                <div class="mb-2">
                  <img *ngIf="collection?.type == 1"
                    src="https://drive-thirdparty.googleusercontent.com/16/type/image/jpeg">
                  <img *ngIf="collection?.type == 2"
                    src="https://drive-thirdparty.googleusercontent.com/16/type/video/mp4">
                  <img *ngIf="collection?.type == 3"
                    src="https://drive-thirdparty.googleusercontent.com/16/type/audio/mpeg">
                  <img *ngIf="collection?.type == 4"
                    src="https://drive-thirdparty.googleusercontent.com/16/type/application/vnd.google-apps.document">
                  <img *ngIf="collection?.type == 5" width="16"
                    src="https://lf16-tiktok-common.ibytedtos.com/obj/tiktok-web-common-sg/mtact/static/pwa/icon_128x128.png">
                  <img *ngIf="collection?.type == 6" width="16"
                    src="https://www.youtube.com/s/desktop/7b8b5af6/img/favicon_32x32.png">
                  <svg *ngIf="collection?.type == 7" width="16" height="16" viewBox="0 0 16 16" fill="currentColor" class="text-danger">
                    <path d="M10.65,1C10.65,1,10.65,1,10.65,1c-0.37,0-0.75,0.1-1.09,0.31L4.25,4.46C3.44,4.93,2.96,5.89,3,6.9  C3.05,7.9,3.58,8.77,4.39,9.18c0.02,0.01,0.75,0.35,0.75,0.35l-0.9,0.53c-1.14,0.68-1.58,2.27-0.98,3.55C3.69,14.49,4.5,15,5.35,15  c0.37,0,0.74-0.1,1.09-0.31l5.31-3.15c0.8-0.48,1.29-1.43,1.24-2.45c-0.04-0.99-0.58-1.87-1.39-2.27c-0.02-0.01-0.75-0.35-0.75-0.35  l0.9-0.53c1.14-0.68,1.58-2.27,0.97-3.55C12.31,1.51,11.49,1,10.65,1L10.65,1z"></path>
                  </svg>
                  <svg *ngIf="collection?.type == 8" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box2-heart" viewBox="0 0 16 16">
                    <path d="M8 7.982C9.664 6.309 13.825 9.236 8 13 2.175 9.236 6.336 6.31 8 7.982"/>
                    <path d="M3.75 0a1 1 0 0 0-.8.4L.1 4.2a.5.5 0 0 0-.1.3V15a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4.5a.5.5 0 0 0-.1-.3L13.05.4a1 1 0 0 0-.8-.4zm0 1H7.5v3h-6zM8.5 4V1h3.75l2.25 3zM15 5v10H1V5z"/>
                  </svg>

                  <small class="ml-2">
                    <span *ngIf="collection?.type < 3 || collection?.type == 5 || collection?.type == 7">
                      {{ collection?.avail_cnt }}/{{ collection?.total_cnt }}
                    </span>
                    <span *ngIf="collection?.type == 4" class="ml-2">
                      {{ collection?.data?.length }}
                    </span>
                    <span *ngIf="collection?.type == 3 || collection?.type == 8" class="ml-2">
                      {{ collection?.data?.data?.length }}
                    </span>
                  </small>
                </div>
                {{ collection?.name }}_{{ collection?.id }}
              </button>

              <button *ngIf="collection?.id == currentCollection?.id && collection.user == username" (click)="btnDelCollection()" type="button"
                [ngClass]="{ 'btn-primary': collection?.id == currentCollection?.id || linkedCollection(collection?.id), 'btn-secondary': collection?.id == currentCollection?.id && !linkedCollection(collection?.id) }"
                class="btn text-danger">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg"
                  viewBox="0 0 16 16">
                  <path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
                </svg>
              </button>
            </div>

            <button
              *ngIf="collectionData.page != -1 && collectionData.results.length >= 20 && !['outdated'].includes(collectionData.filterType)"
              (click)="loadMoreCollections()" [disabled]="collectionData.isLoading" type="button" class="btn btn-outline-secondary m-2">
              <div class="mb-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                  class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                </svg>
              </div>
              Load more
            </button>
          </div>

          <div *ngFor="let collection of collectionData.results" class="collapse" [id]="'collapse-' + collection?.id"
            data-parent="#accordionCollection">
            <div *ngIf="collection?.type < 3 && collection?.id == collectionLoaded">
              <div class="d-flex align-items-center justify-content-between mx-2 mb-2">
                <small class="text-white-50">{{ collection?.name }} files</small>
                <div>
                  <button *ngIf="showUpdateCollectionItem" (click)="updateCollectionItem(collection)" type="button" class="btn btn-sm btn-primary mr-3">
                    Save changes
                  </button>

                  <div class="btn-group">
                    <button (click)="prevPage(paginator.coll)" [disabled]="paginator.coll.page == 0" type="button" class="btn btn-sm btn-secondary">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                      </svg>
                    </button>

                    <button (click)="nextPage(paginator.coll, collection.data.data)" type="button"
                      [disabled]="(paginator.coll.page + 1) * paginator.coll.limit >= collection.data.data.length" class="btn btn-sm btn-secondary">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-wrap">
                <ng-container *ngFor="let item of simplePaginate(paginator.coll, collection.data.data)">
                  <div class="position-relative">
                    <img [src]="item?.poster" onerror="this.style.display='none'" width="170" class="rounded m-2">

                    <button (click)="removeCollectionItem(item);$event.stopPropagation()" type="button"
                      class="btn btn-sm btn-link text-danger position-absolute" style="top:8px;right:8px">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-trash-fill" viewBox="0 0 16 16">
                        <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                      </svg>
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>

            <div *ngIf="collection?.type == 3">
              <div class="d-flex align-items-center mx-2 mb-2">
                <div class="input-group input-group-sm" style="width: 200px">
                  <input class="form-control bg-gray-700 border-secondary text-light"
                    [(ngModel)]="collectionData.new_source_id" placeholder="New source ID" />
                  <div class="input-group-append">
                    <button (click)="addCollectionItem()" [disabled]="!collectionData.new_source_id"
                      type="button" class="btn btn-secondary">Add</button>
                  </div>
                </div>

                <button *ngIf="showUpdateCollectionItem" (click)="updateCollectionItem(collection)" type="button" class="btn btn-sm btn-primary ml-3">
                  Save changes
                </button>
              </div>

              <div *ngFor="let item of collection.data?.data" class="btn-group m-2" role="group">
                <ng-container *ngIf="item?.uri?.split(':')?.pop() as uriSourceId">
                  <button (click)="btnUpdateCollection(uriSourceId)" type="button" class="btn btn-secondary">
                    Source {{ uriSourceId }}
                  </button>

                  <button (click)="removeCollectionItem(item)" type="button" class="btn btn-secondary">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg"
                      viewBox="0 0 16 16">
                      <path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
                    </svg>
                  </button>
                </ng-container>
              </div>
            </div>

            <div *ngIf="collection?.type == 8">
              <div *ngIf="collection?.spcHubList === undefined" class="text-center text-white-50 py-2">
                <span class="spinner-border spinner-border-sm mr-2" role="status"></span> Loading...
              </div>

              <div *ngIf="collection?.spcHubList?.length" class="table-responsive">
                <table class="table table-dark table-sm table-hover mb-0">
                  <thead>
                    <tr>
                      <th>Hub Name</th>
                      <th>Channel ID</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let h of collection?.spcHubList">
                      <td>{{ h?.name }}</td>
                      <td>{{ h?.channel_id }}</td>
                      <td>
                        <span class="badge" [ngClass]="h?.status == '3' ? 'badge-danger' : 'badge-success'">
                          {{ h?.status == '3' ? 'Off' : 'On' }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div *ngIf="collection?.spcHubList?.length === 0" class="text-center text-white-50 py-2">No hub found</div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button (click)="closeCollection()" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <ng-container *ngIf="currentCollection.hasOwnProperty('id') && currentCollection?.id > 0">
          <button *ngIf="(collectionData.isExtend || ((controlType == 'image' || controlType.includes('video') || controlType == 'lyric' || controlType == 'compilation') && layerData.hasOwnProperty('id'))) && currentCollection?.type != 8"
            (click)="btnLinkCollection()" type="button" class="btn btn-primary">Link Data</button>
          <button *ngIf="controlType == 'motion' && layerData.hasOwnProperty('id')"
            (click)="selectCollection()" type="button" class="btn btn-primary">Select</button>
          <button *ngIf="currentCollection?.type == 8"
            (click)="loadSuperCollection()" type="button" class="btn btn-primary">Load Variables</button>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="collectionChildModal" data-backdrop="static">
  <div class="modal-dialog modal-dialog-scrollable"
    [ngClass]="currentCollection?.type == 8 && collectionType == 'edit' ? 'modal-xl spc-modal' : 'modal-lg'">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ collectionType == 'new' ? 'New' : collectionType == 'del' ? 'Delete' : collectionType == 'link' ? 'Link' : 'Edit' }}
        </h5>
        <div class="d-flex align-items-center ml-auto">
          <div *ngIf="collectionType == 'edit' && spcDraft.key" class="d-flex align-items-center mr-3" role="status">
            <small *ngIf="spcDraft.error" class="text-danger">{{ spcDraft.error }}</small>
            <small *ngIf="!spcDraft.error && spcDraft.savedTime" class="text-white-50">Draft saved {{ spcDraft.savedTime * 1000 | date:'HH:mm' }}</small>
          </div>
          <button type="button" class="close" data-dismiss="modal">
            <span>&times;</span>
          </button>
        </div>
      </div>

      <div class="modal-body">
        <div *ngIf="collectionType == 'new'">
          <div class="form-row form-group">
            <div class="col-md">
              <label>Type</label>
              <select [(ngModel)]="collectionData.type" class="custom-select bg-gray-700 border-secondary text-light">
                <option value="1">Image</option>
                <option value="2">Video</option>
                <option value="4">Env</option>
                <option value="8">Super</option>
                <option value="5">TikTok</option>
                <option value="7">Shorts</option>
                <option value="3">Music</option>
                <option value="6">YouTube</option>
              </select>
            </div>

            <div class="col-md">
              <label>Warning threshold</label>
              <input [(ngModel)]="collectionData.warning_threshold" type="number"
                class="form-control bg-gray-700 border-secondary text-light">
            </div>
          </div>

          <div class="form-group">
            <label>Name</label>
            <input [(ngModel)]="collectionData.name" type="text"
              class="form-control bg-gray-700 border-secondary text-light" placeholder="Name">
          </div>
        </div>

        <p *ngIf="collectionType == 'del'">
          <span class="text-danger">{{ currentCollection?.name }}</span> will be deleted forever and you won't be able to restore it.
        </p>

        <p *ngIf="collectionType == 'link' && !collectionData.isExtend">
          <span class="text-warning">{{ currentCollection?.name }}_{{ currentCollection?.id }}</span> collection link to
          <span class="text-warning">{{ layerData?.text }}_{{ layerData?.index }}</span> layer.
        </p>
        <p *ngIf="collectionType == 'link' && collectionData.isExtend">
          <span class="text-warning">{{ currentHub?.name }}</span> hub extend env from  <span class="text-warning">{{ currentCollection?.name }}</span> collection.
        </p>

        <div *ngIf="collectionType == 'edit' && spcDraft.pending" class="text-center py-5" role="alert">
          <p class="mb-3">You have unsaved changes from {{ spcDraft.pending.updated_time * 1000 | date:'HH:mm dd/MM' }}</p>
          <button (click)="restoreSpcDraft()" type="button" class="btn btn-primary mr-2">Restore</button>
          <button (click)="discardSpcDraft()" type="button" class="btn btn-secondary">Discard</button>
        </div>

        <div *ngIf="collectionType == 'edit' && !spcDraft.pending">
          <div class="form-row form-group align-items-end">
            <div class="col-md">
              <label for="collectionName">Name</label>
              <input [(ngModel)]="collectionData.name" type="text"
                class="form-control bg-gray-700 border-secondary text-light" id="collectionName">
            </div>

            <div *ngIf="['3', '5', '7', '8'].includes(currentCollection?.type)" class="col-md">
              <label>Algorithm</label>
              <select [(ngModel)]="collectionData.al" class="form-control bg-gray-700 border-secondary text-light">
                <option value="random-unique">Random Unique</option>
                <option value="random-order">Random Order</option>
                <option value="sequence-unique">Sequence Unique</option>
                <option value="sequence-normal">Sequence Normal</option>
              </select>
            </div>

            <div *ngIf="currentCollection?.type != 8" class="col-md">
              <ng-container *ngTemplateOutlet="shareUsersField"></ng-container>
            </div>
          </div>

          <mat-form-field *ngIf="currentCollection?.type == 7" appearance="fill" class="w-100">
            <mat-label>Choose topics</mat-label>
            <mat-select [compareWith]="editorService.matCompareWith" [ngModel]="collectionData?.shorts?.topics"
              (ngModelChange)="shortsTopicChange($event)" multiple>
              <mat-select-trigger class="text-light">
                {{ collectionData?.shorts?.topics ? collectionData?.shorts?.topics[0]?.topic : '' }}
                <span *ngIf="collectionData?.shorts?.topics?.length > 1">
                  (+{{ collectionData?.shorts?.topics.length - 1 }}
                  {{ collectionData?.shorts?.topics.length == 2 ? 'other' : 'others' }})
                </span>
              </mat-select-trigger>

              <mat-optgroup>
                <mat-form-field class="w-100">
                  <input matInput placeholder="Search" #shortsTopicFilter (keydown)="$event.stopPropagation()">
                </mat-form-field>
              </mat-optgroup>

              <mat-option *ngFor="let t of collectionData?.shorts?.selects" [value]="t"
                [ngClass]="{ 'd-none': !t?.topic.toLowerCase().includes(shortsTopicFilter.value.toLowerCase()) }">
                {{ t.topic }} ({{ t.total }})
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div *ngIf="currentCollection?.type == 6">
            <div class="form-group">
              <label>Algorithm</label>
              <select [(ngModel)]="collectionData.youtube.al"
                class="form-control bg-gray-700 border-secondary text-light">
                <option value="random">Random</option>
                <option value="order">Order</option>
              </select>
            </div>

            <div class="form-group">
              <label>YouTube links</label>
              <textarea [ngModel]="collectionData.youtube?.links" (input)="youtubeLinkChange($event)"
                (paste)="youtubeLinkChange($event)" rows="5"
                class="form-control bg-gray-700 border-secondary text-light"
                placeholder="https://www.youtube.com/watch?v=2S2Xq75bDtM&#10;https://www.youtube.com/playlist?list=PLP96nwbVtj-BnsP-3rIWJNaOjqAB5KZG4&#10;https://www.youtube.com/channel/UCvt5p3A11M8zd8iJPCC5XvQ"></textarea>
            </div>

            <ul *ngIf="collectionData.youtube?.data" class="list-group list-group-flush">
              <li *ngFor="let item of collectionData.youtube?.data; let i = index"
                class="list-group-item bg-gray-700 text-light">
                <div class="form-row d-flex align-items-center">
                  <div class="col-md-4">
                    <input [value]="item?.uri" disabled
                      class="form-control form-control-sm bg-gray-700 border-secondary text-light" type="text">
                  </div>

                  <div class="col-md-1">
                    <div class="custom-control custom-checkbox">
                      <input [ngModel]="item?.is_trim" (ngModelChange)="checkboxTrim($event, i)"
                        [id]="'checkbox-trim-' + i" type="checkbox" class="custom-control-input">
                      <label [attr.for]="'checkbox-trim-' + i" class="custom-control-label">Trim</label>
                    </div>
                  </div>

                  <div *ngIf="item?.is_trim" class="col-md input-group input-group-sm">
                    <input [ngModel]="item?.start" (ngModelChange)="trimChange($event, i, 'start')"
                      class="form-control form-control-sm bg-gray-700 border-secondary text-light border-right-0"
                      type="number" placeholder="Trim start">
                    <div class="input-group-append">
                      <span
                        class="input-group-text bg-gray-700 border-secondary text-secondary border-left-0">seconds</span>
                    </div>
                  </div>

                  <div *ngIf="item?.is_trim" class="col-md input-group input-group-sm">
                    <input [ngModel]="item?.end" (ngModelChange)="trimChange($event, i, 'end')"
                      class="form-control form-control-sm bg-gray-700 border-secondary text-light border-right-0"
                      type="number" placeholder="Trim end">
                    <div class="input-group-append">
                      <span
                        class="input-group-text bg-gray-700 border-secondary text-secondary border-left-0">seconds</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div *ngIf="currentCollection?.type == 8">
            <div class="form-row align-items-start">
              <div class="col-lg">
                <div class="accordion card bg-gray-700 text-light p-3 mb-3" id="accordion-field">
                  <div class="d-flex justify-content-between align-items-center">
                    <button class="btn btn-link text-left text-light text-decoration-none p-0 d-flex align-items-center flex-wrap flex-grow-1" type="button" data-toggle="collapse" data-target="#collapse-field">
                      <span class="text-uppercase small font-weight-bold text-white-50 mr-2">Fields</span>
                      <span *ngFor="let f of collectionData.super.fields" class="badge mr-1" [ngClass]="fieldBadge[f.type]">
                        {{ editorService.convertKeyToName(f.field?.replace('spc_', '')) || '—' }}
                      </span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down ml-2" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                      </svg>
                    </button>

                    <button (click)="spcCopyPrompt()" type="button" class="btn btn-sm btn-link text-light py-0" title="Copy prompt" aria-label="Copy prompt">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clipboard" viewBox="0 0 16 16">
                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                      </svg>
                    </button>
                  </div>

                  <div id="collapse-field" class="collapse" data-parent="#accordion-field">
                    <div class="pt-3">
                      <div *ngFor="let item of collectionData.super.fields; let i = index" class="form-row align-items-end">
                        <div class="col">
                          <label class="small font-weight-bold text-white-50 mb-1">Key</label>
                          <input [(ngModel)]="item.field" (ngModelChange)="ensureMusicTarget(currentEntry)" (keypress)="validVarName($event)" type="text" class="form-control form-control-sm bg-gray-700 border-secondary text-light">
                        </div>

                        <div class="col">
                          <label class="small font-weight-bold text-white-50 mb-1">Type</label>
                          <select [(ngModel)]="item.type" (ngModelChange)="ensureMusicTarget(currentEntry); $event == 'footage' && loadFootageSources()" class="custom-select custom-select-sm bg-gray-700 border-secondary text-light">
                            <option value="string">String</option>
                            <option value="text">Text</option>
                            <option value="image">Image</option>
                            <option value="video">Video</option>
                            <option value="footage">Footage</option>
                            <option value="music" [disabled]="musicField && musicField !== item">Music</option>
                          </select>
                        </div>

                        <div class="col-auto">
                          <button (click)="deleteField(i)" type="button" class="btn btn-sm btn-link text-danger" aria-label="Delete field">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                              <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                            </svg>
                          </button>

                          <button (click)="newField()" type="button" class="btn btn-sm btn-link text-white" aria-label="Add field">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                              <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="resourceFields.length" class="col-lg">
                <div class="accordion card bg-gray-700 text-light p-3 mb-3" id="accordion-bulk">
                  <button class="btn btn-link text-left text-light text-decoration-none p-0 d-flex align-items-center flex-wrap" type="button" data-toggle="collapse" data-target="#collapse-bulk">
                    <span class="text-uppercase small font-weight-bold text-white-50 mr-2">Bulk uploads</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down ml-2" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                    </svg>
                  </button>

                  <div id="collapse-bulk" class="collapse" data-parent="#accordion-bulk">
                    <div class="pt-3">
                      <div *ngFor="let item of resourceFields; let i = index" class="mb-2">
                        <label class="small font-weight-bold text-white-50 text-capitalize mb-1">{{ item.type }}</label>

                        <div class="custom-file mb-2">
                          <input type="file" class="custom-file-input" [attr.id]="item.type + 'Files' + i"
                            [attr.accept]="item.type == 'image' ? 'image/*' : '.avi,.m4v,.mp4,.webm,.gif'" multiple
                            (change)="awsFilesInput($event.target.files, item.type, i)">
                          <span class="custom-file-label bg-gray-700 border-secondary text-light" [attr.for]="item.type + 'Files' + i">
                            <span *ngIf="!entryLoading || entryLoading != item.type + 'Files' + i">Choose files{{ item.type == 'video' ? ' (AVI, M4V, MP4, WEBM or GIF)' : '' }}</span>
                            <span *ngIf="entryLoading == item.type + 'Files' + i" class="spinner-border spinner-border-sm"></span>
                          </span>
                        </div>

                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text" [attr.for]="item.type + 'Drive' + i">
                              <img *ngIf="!entryLoading || entryLoading != item.type + 'Drive' + i" src="https://ssl.gstatic.com/images/branding/product/1x/drive_2020q4_32dp.png" width="20" alt="Google Drive">
                              <span *ngIf="entryLoading == item.type + 'Drive' + i" class="spinner-border spinner-border-sm"></span>
                            </span>
                          </div>
                          <input type="text" class="form-control bg-gray-700 border-secondary text-light"
                            placeholder="Drive folder link" [attr.id]="item.type + 'Drive' + i"
                            (keyup.enter)="zipFileInput($event.target.value, item.type, i)">
                        </div>

                        <div *ngIf="uploadStatus[item.type]?.progress && uploadStatus[item.type]?.progress < 100" class="progress mt-2" style="height: 10px;">
                          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" [style.width.%]="uploadStatus[item.type].progress" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                            {{ uploadStatus[item.type].count }}/{{ uploadStatus[item.type].total }} files
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex align-items-center text-uppercase small font-weight-bold text-white-50 mb-2">
              Entries
              <span class="badge badge-pill badge-light ml-2">{{ collectionData.super.data.length }}</span>
            </div>

            <div class="accordion" id="accordion-entry">
              <div *ngFor="let entry of collectionData.super.data; let i = index" class="card bg-gray-700 text-light rounded mb-2 spc-entry"
                [class.border-primary]="currentEntry == i" [hidden]="!entryVisible(paginator.entry, i)">
                <div class="card-header bg-transparent border-0 p-0 d-flex justify-content-between align-items-center">
                  <button (click)="entryClick(i)" class="btn btn-link btn-block text-left text-light text-decoration-none d-flex align-items-center" type="button" data-toggle="collapse" [attr.data-target]="'#collapse-entry-' + i">
                    <span class="small font-weight-bold text-info mr-2">#{{ i + 1 }}</span>
                    <span class="text-truncate mr-2">{{ entryTitle(entry) || 'Untitled' }}</span>
                    <span *ngIf="entryHas(entry, 'image')" class="badge mr-1" [ngClass]="fieldBadge.image">Image</span>
                    <span *ngIf="entryHas(entry, 'video')" class="badge mr-1" [ngClass]="fieldBadge.video">Video</span>
                    <span *ngIf="entryHas(entry, 'footage')" class="badge mr-1" [ngClass]="fieldBadge.footage">Footage</span>
                    <span *ngIf="musicField" class="badge ml-auto" [ngClass]="entryTrackCount(entry) ? fieldBadge.music : 'badge-dark'">&#9834; {{ entryTrackCount(entry) }} tracks</span>
                  </button>

                  <div class="d-flex">
                    <button (click)="deleteEntry(i)" type="button" class="btn btn-sm btn-link text-danger" aria-label="Delete entry">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                      </svg>
                    </button>

                    <button (click)="cloneEntry(i)" type="button" class="btn btn-sm btn-link text-white" title="Clone entry" aria-label="Clone entry">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-copy" viewBox="0 0 16 16" aria-hidden="true">
                        <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"/>
                      </svg>
                    </button>

                    <button (click)="addEntry(i)" type="button" class="btn btn-sm btn-link text-white" aria-label="Add entry">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z" />
                      </svg>
                    </button>
                  </div>
                </div>

                <div [attr.id]="'collapse-entry-' + i" class="collapse {{i == collectionData.super.data.length - 1 ? 'show' : ''}}" data-parent="#accordion-entry">
                  <div class="row no-gutters border-top border-secondary">
                    <div class="p-3 spc-entry-content" [ngClass]="musicField ? 'col-lg-5' : 'col-12'">
                      <div *ngFor="let item of entryFields" class="form-group">
                        <label class="small font-weight-bold text-white-50 mb-1">{{ editorService.convertKeyToName(item.field?.replace('spc_', '')) }}</label>

                        <input *ngIf="item.type == 'string'" [(ngModel)]="entry[item.field]" type="text" class="form-control bg-gray-700 border-secondary text-light">

                        <textarea *ngIf="item.type == 'text'" [(ngModel)]="entry[item.field]" rows="3" class="form-control bg-gray-700 border-secondary text-light"></textarea>

                        <mat-form-field *ngIf="item.type == 'footage'" appearance="fill" class="w-100">
                          <mat-label>Moon sources</mat-label>

                          <mat-select [ngModel]="entry[item.field]?.source_users" (ngModelChange)="footageChange(entry, item.field, $event)"
                            (openedChange)="$event && loadFootageSources()"
                            [compareWith]="editorService.matCompareWithId" [sortComparator]="editorService.noSortComparator" multiple>
                            <mat-select-trigger class="text-light">
                              {{ entry[item.field]?.source_users?.length ? entry[item.field].source_users[0].name : '' }}
                              <span *ngIf="entry[item.field]?.source_users?.length > 1">
                                (+{{ entry[item.field].source_users.length - 1 }}
                                {{ entry[item.field].source_users.length == 2 ? 'other' : 'others' }})
                              </span>
                            </mat-select-trigger>

                            <mat-optgroup>
                              <mat-form-field class="w-100">
                                <input matInput placeholder="Search" aria-label="Search sources" #footageFilter (keydown)="$event.stopPropagation()">
                              </mat-form-field>
                            </mat-optgroup>

                            <mat-option *ngIf="footage.isLoading" disabled>Loading...</mat-option>
                            <mat-option *ngIf="footage.hasError" disabled>Could not load sources, open again to retry</mat-option>
                            <mat-option *ngIf="!footage.isLoading && !footage.hasError && !footageOptions(entry, item.field).length" disabled>No source</mat-option>
                            <mat-option *ngFor="let su of footageOptions(entry, item.field)"
                              [ngClass]="{ 'd-none': !su?.name?.toLowerCase().includes(footageFilter.value.toLowerCase()) }" [value]="su">
                              {{ su?.name }}<ng-container *ngIf="su?.stats"> ({{ su.stats.footage || 0 }})</ng-container>
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                        <ng-container *ngIf="item.type == 'image' || item.type == 'video'">
                          <div class="d-flex align-items-center">
                            <div *ngIf="entry[item.field]?.poster" class="mr-3">
                              <img [src]="entry[item.field].poster" width="64" height="64" class="rounded object-cover" alt="">
                            </div>

                            <div class="custom-file">
                              <input type="file" class="custom-file-input" [attr.id]="item.type + 'File' + i"
                                [attr.accept]="item.type == 'image' ? 'image/*' : '.avi,.m4v,.mp4,.webm,.gif'"
                                (change)="awsFileInput($event.target.files[0], item.type, entry, item.field, i)">
                              <span class="custom-file-label bg-gray-700 border-secondary text-light" [attr.for]="item.type + 'File' + i">
                                <span *ngIf="!entryLoading || entryLoading != item.type + 'File' + i">Choose file{{ item.type == 'video' ? ' (AVI, M4V, MP4, WEBM or GIF)' : '' }}</span>
                                <span *ngIf="entryLoading == item.type + 'File' + i" class="spinner-border spinner-border-sm"></span>
                              </span>
                            </div>
                          </div>

                          <div *ngIf="uploadStatus[item.type]?.progress && uploadStatus[item.type]?.progress < 100" class="progress mt-3" style="height: 10px;">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" [style.width.%]="uploadStatus[item.type].progress" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                              {{ uploadStatus[item.type].count }}/{{ uploadStatus[item.type].total }} files
                            </div>
                          </div>

                          <div *ngIf="currentEntry == i && driveResource[item.type].length" class="mt-3">
                            <ng-container *ngTemplateOutlet="resourceGrid; context: { resources: driveResource[item.type], pager: paginator[item.type], type: item.type, entry: entry, field: item.field, collection: null }"></ng-container>
                          </div>

                          <ng-container *ngIf="currentEntry == i">
                            <mat-form-field appearance="fill" class="w-100 mt-3">
                              <mat-label>Choose from collection</mat-label>

                              <mat-select [ngModel]="collectionOf(entry, item.field, item.type)" (ngModelChange)="chooseEntryCollection(entry, item.field, item.type, $event)"
                                (openedChange)="$event && openSpcCollections(item.type)" [compareWith]="editorService.matCompareWithId">
                                <mat-select-trigger class="text-light">{{ collectionOf(entry, item.field, item.type)?.name }}_{{ collectionOf(entry, item.field, item.type)?.id }}</mat-select-trigger>

                                <mat-optgroup>
                                  <mat-form-field class="w-100">
                                    <input matInput placeholder="Search by ID or name, then Enter" aria-label="Search collections" (keydown)="$event.stopPropagation()"
                                      [value]="spcCollections[item.type].search" (keyup.enter)="searchSpcCollections(item.type, $event.target.value)">
                                  </mat-form-field>
                                </mat-optgroup>

                                <mat-option *ngIf="spcCollections[item.type].isLoading" disabled>Loading...</mat-option>
                                <mat-option *ngIf="spcCollections[item.type].hasError" disabled>Could not load collections, search again</mat-option>
                                <mat-option *ngIf="!spcCollections[item.type].isLoading && !spcCollections[item.type].hasError && !spcCollectionOptions(item.type, collectionOf(entry, item.field, item.type)).length" disabled>No collection</mat-option>
                                <mat-option *ngFor="let c of spcCollectionOptions(item.type, collectionOf(entry, item.field, item.type))" [value]="c">
                                  {{ c.name }}_{{ c.id }} ({{ c.avail_cnt }}/{{ c.total_cnt }})
                                </mat-option>
                              </mat-select>
                            </mat-form-field>

                            <div *ngIf="collectionOf(entry, item.field, item.type) as collection" class="mt-3">
                              <ng-container *ngIf="collection.data?.data?.length; else emptyCollection">
                                <ng-container *ngTemplateOutlet="resourceGrid; context: { resources: collection.data.data, pager: spcPicks.pagers[collection.id], type: item.type, entry: entry, field: item.field, collection: collection }"></ng-container>
                              </ng-container>
                              <ng-template #emptyCollection>
                                <div class="small text-white-50">This collection has no files</div>
                              </ng-template>
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>

                    <div *ngIf="musicField" class="col-lg-7 p-3">
                      <div class="d-flex align-items-center flex-wrap mb-2">
                        <span class="text-uppercase small font-weight-bold text-white-50">Music</span>
                        <span *ngIf="entryMusicSummary(entry) as summary" class="small ml-2" [ngClass]="summary.total ? 'text-warning' : 'text-white-50'">
                          {{ summary.total }} Tracks<ng-container *ngIf="summary.total">
                          (<span *ngFor="let item of summary.musicTypes | keyvalue; let last = last">{{ item.key }}: {{ item.value }}<ng-container *ngIf="!last">, </ng-container></span>)</ng-container>
                        </span>
                      </div>

                      <app-music-picker *ngIf="currentEntry == i && musicTargetOf(entry) as target" #spcMusicPicker mode="compilation" [target]="target"
                        [boomGenres]="boomGenres" [isPortrait]="isPortrait" [isAutoInit]="true"
                        [hasTrackDetails]="true" [hasLyricSync]="autoTemplate?.type == 1" [hasClaimGroup]="true"
                        [validationErrors]="spcValidationErrors"></app-music-picker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <ng-container *ngIf="currentCollection?.type == 8 && collectionType == 'edit' && !spcDraft.pending">
          <div style="width: 160px">
            <ng-container *ngTemplateOutlet="shareUsersField"></ng-container>
          </div>
          <div class="input-group ml-auto mr-2" style="width: 300px">
            <div class="input-group-prepend">
              <button (click)="spcFileInput.click()" type="button" class="btn btn-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-arrow-up" viewBox="0 0 16 16">
                  <path d="M8.5 11.5a.5.5 0 0 1-1 0V7.707L6.354 8.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 7.707z"/>
                  <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                </svg>
              </button>
              <input type="file" (change)="spcImportFromFile($event)" accept=".json,.txt" class="d-none" #spcFileInput>
            </div>
            <textarea rows="1" class="form-control bg-gray-700 border-secondary text-light" style="max-height: 400px"
              [(ngModel)]="collectionData.spc_json_data" placeholder="JSON Data"></textarea>
            <div class="input-group-append">
              <button (click)="spcImport()" [disabled]="!collectionData.spc_json_data" type="button" class="btn btn-secondary">
                Import
              </button>
              <button (click)="collectionData.super.data = []" type="button" class="btn btn-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-counterclockwise" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"/>
                  <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466"/>
                </svg>
              </button>
            </div>
          </div>
          <div class="btn-group">
            <button (click)="prevPage(paginator.entry)" [disabled]="paginator.entry.page == 0" type="button" class="btn btn-secondary"
              data-toggle="tooltip" data-placement="top" title="Prev Entries">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
              </svg>
            </button>

            <button (click)="nextPage(paginator.entry, collectionData.super.data)" type="button"
              [disabled]="(paginator.entry.page + 1) * paginator.entry.limit >= collectionData.super.data.length" class="btn btn-secondary"
              data-toggle="tooltip" data-placement="top" title="Next Entries">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
              </svg>
            </button>
          </div>
        </ng-container>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button
          (click)="collectionType == 'new' ? newCollection() : collectionType == 'del' ? delCollection() : collectionType == 'link' ? linkCollection() : editCollection()"
          [disabled]="(!collectionData.name.trim() && collectionType == 'new') || (collectionType == 'edit' && spcDraft.pending)" type="button" class="btn btn-primary">
          {{ collectionType == 'new' ? 'Create' : collectionType == 'del' ? 'Delete' : collectionType == 'link' ? 'Link' : 'Update' }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="checkMusicModal" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Music Checking</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label for="playlistText">Spotify playlists</label>
          <textarea class="form-control bg-dark border-secondary text-light" id="playlistText" rows="3"
            placeholder="https://open.spotify.com/playlist/3Ofm8CHJMRcSKWTf8qHJgx"
            [ngModel]="checkMusicData.link_text" (input)="playlistTextChange($event)"
            (paste)="playlistTextChange($event)"></textarea>
        </div>

        <ul *ngIf="checkMusicData?.music_data?.length" class="list-group list-group-flush">
          <ng-container *ngFor="let item of sortedMusicData(checkMusicData.music_data); let i = index">
            <li class="list-group-item bg-dark text-light">
              <div class="form-row d-flex align-items-center">
                <div class="col-md-1 d-flex align-items-center justify-content-between pl-0">
                  <div *ngIf="item?.is_fuk_artist" title="This artist FUK your channel">⛔</div>

                  <svg *ngIf="item?.is_deezer || item?.direct_link" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-lg text-success" viewBox="0 0 16 16">
                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z"/>
                  </svg>

                  <svg *ngIf="!item?.is_deezer && !item?.direct_link" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg text-danger" viewBox="0 0 16 16">
                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
                  </svg>

                  <img height="16px" src="/assets/images/spotify.png">
                </div>

                <div class="col-md-3 text-truncate" title="{{ item?.track?.artists[0]?.name }} - {{ item?.track?.name }}">
                  {{ item?.track?.artists[0]?.name }} - {{ item?.track?.name }}
                </div>

                <div class="col-md">
                  <input class="form-control form-control-sm bg-dark border-secondary text-light" type="text"
                    value="{{ item?.track?.id }}" disabled>
                </div>

                <div *ngIf="!item?.is_deezer" class="col-md-5 input-group input-group-sm">
                  <input class="form-control form-control-sm bg-dark border-secondary text-light" type="text" placeholder="YouTube URL"
                    [ngModel]="item.youtube_id" (input)="onYoutubeChange($event, item)" (paste)="onYoutubeChange($event, item)"
                    [attr.list]="'spotify-list-' + item?.track?.id">

                  <select class="custom-select bg-dark border-secondary text-light" [(ngModel)]="item.genre">
                    <option [value]="undefined" disabled hidden>Select...</option>
                    <option [value]="item?.name" *ngFor="let item of boomGenres">
                      {{ item?.name }}
                    </option>
                  </select>

                  <div *ngIf="item?.youtube_id && item.genre && !item?.direct_link" class="input-group-append">
                    <button (click)="mapSpotifyYoutube($event, item)" class="btn btn-sm btn-secondary" type="button">Save</button>
                  </div>

                  <datalist id="spotify-list-{{ item?.track?.id }}">
                    <option *ngFor="let o of checkMusicData[item?.track?.id]" [value]="o?.source_id">{{ o?.username }} - {{ o?.sync == 1 ? 'Available' : 'Not Available' }}</option>
                  </datalist>
                </div>

                <div *ngIf="!item?.is_deezer" class="ml-2">
                  <a href="https://www.youtube.com/results?search_query={{ item?.track?.artists[0]?.name }} {{ item?.track?.name }}" target="_blank" rel="nofollow">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                      <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"/>
                    </svg>
                  </a>
                </div>
              </div>
            </li>
          </ng-container>
        </ul>

        <div *ngIf="checkMusicData?.loading && !checkMusicData?.music_data?.length" class="d-flex align-items-center justify-content-center">
          <span class="spinner-border spinner-border-sm mr-2" role="status"></span> Checking...
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button (click)="forceDownloadMusic($event)" [disabled]="!checkMusicData?.music_data?.length" type="button" class="btn btn-info">
          Force Download
        </button>
        <button (click)="exportSpotifyTimestamp($event)" [disabled]="!checkMusicData?.music_data?.length" type="button" class="btn btn-info">
          Export Timestamp
        </button>
        <button (click)="exportCheckMusic($event)" [disabled]="!checkMusicData?.music_data?.length" type="button" class="btn btn-info">
          Export Music
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="boomMixModal" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Boom Mix</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label for="driveLinks">Drive links</label>
          <textarea [ngModel]="boomMixData?.links" (input)="driveLinkChange($event)" (paste)="driveLinkChange($event)"
            class="form-control bg-dark border-secondary text-light" id="driveLinks" rows="5"
            placeholder="https://drive.google.com/uc?id=1vYl-C3MRuZ1b7df38Je7jFd0Up541gxO&sv=studio"></textarea>
        </div>

        <div class="row">
          <div class="col form-group">
            <div class="custom-control custom-radio custom-control-inline">
              <input [ngModel]="boomMixData.topic_type" (ngModelChange)="boomMixTopicTypeChange($event)" value="CLAIM"
                type="radio" id="boomMixTopicTypeClaim" name="boomMixTopicType" class="custom-control-input">
              <label class="custom-control-label" for="boomMixTopicTypeClaim">Claim</label>
            </div>

            <div class="custom-control custom-radio custom-control-inline">
              <input [ngModel]="boomMixData.topic_type" (ngModelChange)="boomMixTopicTypeChange($event)" value="PROMOS"
                type="radio" id="boomMixTopicTypePromo" name="boomMixTopicType" class="custom-control-input">
              <label class="custom-control-label" for="boomMixTopicTypePromo">Promo</label>
            </div>

            <select [(ngModel)]="boomMixData.topic" [disabled]="!boomMixData.hasOwnProperty('topic_type')"
              class="custom-select bg-dark border-secondary text-light mt-2">
              <option value="">Choose a topic</option>
              <option [value]="item?.topic" *ngFor="let item of claimList">{{ item?.topic }}</option>
            </select>
          </div>

          <div class="col form-group">
            <label for="claimPos">Claim position</label>
            <input [(ngModel)]="boomMixData.pos" type="number" class="form-control bg-dark border-secondary text-light"
              id="claimPos">
          </div>
        </div>

        <div>
          <small *ngIf="!boomMixData?.result">Download link will appear here</small>
          <a *ngIf="boomMixData?.result" [href]="'https://drive.google.com/uc?id=' + boomMixData.result.split(';;')[2]"
            target="_blank" rel="nofollow">Download</a>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button (click)="saveBoomMix($event)" type="button" class="btn btn-primary">
          <span *ngIf="boomMixData?.isRendering" class="spinner-border spinner-border-sm" role="status"></span>
          Render
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="['sangmusic', 'tungtt'].includes(username)" class="modal fade" id="viewer-modal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Viewer</h5>
        <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
      </div>

      <div class="modal-body">
        <ul class="nav nav-pills" id="viewerTab" role="tablist">
          <li class="nav-item" role="presentation">
            <a (click)="viewer.type = 1" class="nav-link active" data-toggle="pill" href="#viewer-url"
              role="tab">Url</a>
          </li>
          <li class="nav-item" role="presentation">
            <a (click)="viewer.type = 2" class="nav-link" data-toggle="pill" href="#viewer-home" role="tab">Home</a>
          </li>
        </ul>

        <div class="tab-content pt-3" id="viewerTabContent">
          <div class="row align-items-center mb-3">
            <mat-form-field appearance="fill" class="col-md-4">
              <mat-label>Choose accounts</mat-label>

              <mat-select (selectionChange)="accountChanged($event)" [formControl]="accountCtrl" multiple>
                <mat-select-trigger class="text-light">
                  {{ accountCtrl.value?.length ? accountCtrl.value[0].chanel_name : '' }}
                  <span *ngIf="accountCtrl.value?.length > 1">
                    (+{{ accountCtrl.value.length - 1 }} {{ accountCtrl.value?.length == 2 ? 'other' : 'others' }})
                  </span>
                </mat-select-trigger>

                <mat-optgroup>
                  <mat-form-field class="w-100">
                    <input matInput placeholder="Search" #accountFilter (keydown)="$event.stopPropagation()">
                    <button *ngIf="accountFilter.value?.length" matSuffix mat-icon-button
                      (click)="accountFilter.value=''">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>
                </mat-optgroup>

                <mat-checkbox class="mat-option" [indeterminate]="isIndeterminate(accountCtrl, channelList)"
                  [checked]="isChecked(accountCtrl, channelList)" (click)="$event.stopPropagation()"
                  (change)="toggleSelection($event, accountCtrl, channelList)">
                  Select all
                </mat-checkbox>

                <mat-option *ngFor="let c of channelList"
                  [ngClass]="{ 'd-none': !c.chanel_name?.toLowerCase().includes(accountFilter.value.toLowerCase()) }"
                  [value]="c">
                  {{ c.chanel_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <div class="col-md-4">
              <div class="input-group" style="height:61.5px">
                <input [(ngModel)]="viewer.time_sec" type="number"
                  class="form-control bg-dark border-secondary text-light border-right-0 h-100" placeholder="watchtime">
                <div class="input-group-append">
                  <span class="input-group-text bg-dark border-secondary text-light border-left-0">seconds</span>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="custom-control custom-checkbox custom-control-inline">
                <input [(ngModel)]="viewer.is_like" type="checkbox" class="custom-control-input" id="isLike">
                <label class="custom-control-label" for="isLike">Like</label>
              </div>

              <div class="custom-control custom-checkbox custom-control-inline">
                <input [(ngModel)]="viewer.is_subscribe" type="checkbox" class="custom-control-input" id="isSubscribe">
                <label class="custom-control-label" for="isSubscribe">Subscribe</label>
              </div>
            </div>
          </div>

          <div class="tab-pane fade show active" id="viewer-url" role="tabpanel">
            <div class="form-group">
              <label for="targetUrl">Target url</label>
              <input [(ngModel)]="viewer.target_url" type="text"
                class="form-control bg-dark border-secondary text-light" id="targetUrl"
                placeholder="https://www.youtube.com/watch?v=xxx">
            </div>
          </div>

          <div class="tab-pane fade" id="viewer-home" role="tabpanel">
            <div class="form-group">
              <label for="targetSource">Target source</label>
              <input [(ngModel)]="viewer.target_source" type="text"
                class="form-control bg-dark border-secondary text-light" id="targetSource"
                placeholder="https://www.youtube.com/{watch|c|channel}=xxx">
            </div>

            <div class="form-group">
              <label for="excludeVideos">Exclude videos</label>
              <textarea [(ngModel)]="viewer.exclude_videos" class="form-control bg-dark border-secondary text-light"
                id="excludeVideos" rows="3" placeholder="https://www.youtube.com/watch?v=xxx"></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button (click)="viewerClicked($event)" type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="hubAskMetaModal">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content bg-dark text-light">
      <div class="modal-header">
        <h5 class="modal-title">Moon AI</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="form-group d-flex align-items-center justify-content-between">
          <mat-form-field appearance="fill">
            <mat-label>Language</mat-label>
            <mat-select [compareWith]="editorService.matCompareWith" [(ngModel)]="askMetaData.language">
              <mat-select-trigger class="text-light">{{ askMetaData?.language }}</mat-select-trigger>

              <mat-optgroup>
                <mat-form-field class="w-100">
                  <input matInput placeholder="Search" #langFilter (keydown)="$event.stopPropagation()">
                </mat-form-field>
              </mat-optgroup>

              <mat-option *ngFor="let item of askMetaData.languages" [value]="item"
                [ngClass]="{ 'd-none': !item?.toLowerCase()?.includes(langFilter.value.toLowerCase()) }">
                {{ item }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Prompts</mat-label>
            <mat-select [compareWith]="editorService.matCompareWithId" [ngModel]="askMetaData?.prompted" (ngModelChange)="promptedChange($event)">
              <mat-select-trigger class="text-light">{{ askMetaData?.prompted?.name }}</mat-select-trigger>

              <mat-optgroup>
                <mat-form-field class="w-100">
                  <input matInput placeholder="Search" #promptFilter (keydown)="$event.stopPropagation()">
                </mat-form-field>
              </mat-optgroup>

              <mat-option *ngFor="let item of askMetaData.prompts" [value]="item"
                [ngClass]="{ 'd-none': !item?.name?.toLowerCase()?.includes(promptFilter.value.toLowerCase()) }">
                {{ item?.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-group">
          <div mwlTextInputHighlightContainer>
            <textarea mwlTextInputElement #promptRef class="form-control bg-transparent border-secondary text-light"
              rows="8" [mentionConfig]="askMetaData.mention_config" [ngModel]="askMetaData?.prompt"
              (ngModelChange)="promptChange($event)" placeholder="Ask, write, or search for anything"></textarea>
            <mwl-text-input-highlight [tags]="highlightTag?.prompt" [textInputElement]="promptRef">
            </mwl-text-input-highlight>
          </div>
        </div>

        <div *ngIf="askMetaData?.loading" class="d-flex align-items-center justify-content-center">
          <span class="spinner-grow spinner-grow-sm mr-2" role="status"></span> Generating...
        </div>

        <div *ngIf="askMetaData?.meta_config?.title">
          <div class="accordion form-group" id="accordionEnv">
            <div *ngFor="let item of askMetaData?.env_config; let i = index" class="card bg-dark text-light">
              <div class="card-header p-0 d-flex justify-content-between align-items-center">
                <button class="btn btn-link btn-block text-left text-light" type="button" data-toggle="collapse"
                  [attr.data-target]="'#collapse-env-' + i">
                  {{ item?.name }}
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down ml-2" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                  </svg>
                </button>

                <button (click)="copyGenEnv(item)" type="button" class="btn btn-link">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-clipboard"
                    viewBox="0 0 16 16" data-toggle="tooltip" data-placement="top" title="Copy">
                    <path
                      d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                    <path
                      d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                  </svg>
                </button>
              </div>

              <div [attr.id]="'collapse-env-' + i" class="collapse" data-parent="#accordionEnv">
                <div class="card-body">
                  <div class="badge badge-pill badge-secondary m-1 d-inline-flex align-items-center justify-content-between"
                    *ngFor="let v of item?.value; let j = index">
                    <input type="text" class="form-control form-control-sm bg-transparent border-0 text-light"
                      [(ngModel)]="item.value[j]" title="{{ v }}">

                    <button (click)="item.value.splice(j, 1)" type="button" class="btn btn-link text-light p-0">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="videoTitle">Title</label>
            <div class="d-flex align-items-center">
              <textarea #titleCopy class="form-control bg-dark border-secondary text-light" id="videoTitle" rows="1"
                [ngModel]="askMetaData?.meta_config?.title"></textarea>
              <button type="button" class="btn btn-link" [ngxClipboard]="titleCopy">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-clipboard"
                  viewBox="0 0 16 16" data-toggle="tooltip" data-placement="top" title="Copy">
                  <path
                    d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                  <path
                    d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                </svg>
              </button>
            </div>
          </div>

          <div class="form-group">
            <label for="videoDesc">Description</label>
            <div class="d-flex align-items-center">
              <textarea #descCopy class="form-control bg-dark border-secondary text-light" id="videoDesc" rows="5"
                [ngModel]="askMetaData?.meta_config?.description"></textarea>
              <button type="button" class="btn btn-link" [ngxClipboard]="descCopy">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-clipboard"
                  viewBox="0 0 16 16" data-toggle="tooltip" data-placement="top" title="Copy">
                  <path
                    d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                  <path
                    d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                </svg>
              </button>
            </div>
          </div>

          <div class="form-group">
            <label for="videoTags">Tags</label>
            <div class="d-flex align-items-center">
              <textarea #tagCopy class="form-control bg-dark border-secondary text-light" id="videoTags" rows="5"
                [ngModel]="askMetaData?.meta_config?.tags"></textarea>
              <button type="button" class="btn btn-link" [ngxClipboard]="tagCopy">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-clipboard"
                  viewBox="0 0 16 16" data-toggle="tooltip" data-placement="top" title="Copy">
                  <path
                    d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                  <path
                    d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button (click)="deletePrompt($event)" *ngIf="askMetaData?.prompted" class="btn btn-danger mr-auto"
          title="Delete Prompt: {{ askMetaData?.prompted?.name }}" type="button">
          Delete
        </button>
        <div class="input-group" style="width: 250px">
          <input type="text" class="form-control bg-dark border-secondary text-light"
            [(ngModel)]="askMetaData.name" placeholder="Prompt name">
          <div class="input-group-append">
            <button (click)="addPrompt($event)" [disabled]="!askMetaData?.prompt || !askMetaData?.name"
              data-toggle="tooltip" data-placement="top" title="Save as New Prompt" type="button" class="btn btn-secondary">
              Save
            </button>
          </div>
        </div>
        <button (click)="fillToEnv($event)" [disabled]="!askMetaData?.meta_config?.title" type="button" class="btn btn-secondary">
          Fill Env
        </button>
        <button (click)="fillToMeta($event)" [disabled]="!askMetaData?.meta_config?.title" type="button" class="btn btn-secondary">
          Fill Meta
        </button>
        <button (click)="askMeta($event)" [disabled]="!askMetaData?.prompt || askMetaData?.loading" type="button" class="btn btn-info">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-stars" viewBox="0 0 16 16">
            <path d="M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.73 1.73 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.73 1.73 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.73 1.73 0 0 0 3.407 2.31zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z"/>
          </svg>
          Generate
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #resourceGrid let-resources="resources" let-pager="pager" let-type="type" let-entry="entry" let-field="field" let-collection="collection">
  <div class="d-flex justify-content-end">
    <div class="btn-group">
      <button (click)="prevPage(pager)" [disabled]="pager.page == 0" type="button" class="btn btn-sm btn-secondary" aria-label="Previous">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
        </svg>
      </button>

      <button (click)="nextPage(pager, resources)" type="button" aria-label="Next"
        [disabled]="(pager.page + 1) * pager.limit >= resources.length" class="btn btn-sm btn-secondary">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
        </svg>
      </button>
    </div>
  </div>

  <div *ngIf="usedResourceIds() as used" class="d-flex flex-wrap">
    <div *ngFor="let rs of simplePaginate(pager, resources)" (click)="pickResource(rs, type, entry, field, collection)" role="button">
      <img [src]="rs?.poster" onerror="this.style.display='none'" width="127" class="rounded m-2" alt=""
        [ngStyle]="used.has('' + rs.resource_id) && { filter: 'grayscale(1)', opacity: 0.3 }">
    </div>
  </div>
</ng-template>

<ng-template #shareUsersField>
  <mat-form-field appearance="fill" class="w-100">
    <mat-label>Share users</mat-label>
    <mat-select [compareWith]="editorService.matCompareWith" [(ngModel)]="collectionData.share_user" multiple>
      <mat-select-trigger class="text-light">
        {{ collectionData?.share_user ? collectionData?.share_user[0] : '' }}
        <span *ngIf="collectionData?.share_user?.length > 1">
          (+{{ collectionData?.share_user.length - 1 }}
          {{ collectionData?.share_user.length == 2 ? 'other' : 'others' }})
        </span>
      </mat-select-trigger>
      <mat-optgroup>
        <mat-form-field class="w-100">
          <input matInput placeholder="Search" #shareFilter (keydown)="$event.stopPropagation()">
        </mat-form-field>
      </mat-optgroup>
      <mat-option value="company">All</mat-option>
      <mat-option *ngFor="let u of userList" [value]="u"
        [ngClass]="{ 'd-none': !u.toLowerCase().includes(shareFilter.value.toLowerCase()) }">
        {{ u }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>
